<template>
  <header>
    <nav :class="loginStatus['prodInst'] !== '1' ? 'navbar navbar-expand-lg navbar-light main-color fixed-top' : 'navbar navbar-expand-lg navbar-light fixed-top prod-inst-color'">
      <BButton id="menu-trigger" class="me-3" :class="{ active: showSidebar1 }" @click="onClickMenuButton">
        <span></span>
        <span></span>
        <span></span>
      </BButton>
      <p class="mb-0 me-3" id="logo" style="cursor:default;user-select:none">
        <span class="test-header-color align-middle" v-if="app_env !== 'production'">
          【テスト環境】
        </span>
      </p>
      <BNavItemDropdown
        :text="config.projectName"
        class="list-unstyled mb-0 me-3 h2"
        :toggle-class="['header-image-upload-btn', 'text-light']"
        menu-class="main-color"
        no-caret
        v-if="loginStatus['beforeLogin'] !== '1'">
        <BDropdownItem :class="['text-light', 'main-color-hover']" @click="moveToAgenda()" v-if="loginStatus['prodInst'] !== '1'">アジェンダ</BDropdownItem>
        <BDropdownItem :class="['text-light', 'main-color-hover']" @click="moveToInput()" v-if="loginStatus['prodInst'] !== '1'">お客様情報入力</BDropdownItem>
        <BDropdownItem :class="['text-light', 'main-color-hover']" @click="moveToHearing()">ヒアリング</BDropdownItem>
      </BNavItemDropdown>
      <div class="mb-0 me-3 h2 nav-link" style="color:white" v-else>
        {{this.config.projectName}}
      </div>
      <BNavItemDropdown
        text="お気に入り画像"
        v-if="this.consts.floristHeaderImageUploadMenuShowPages.includes(this.$parent.$parent.$options.name)"
        class="list-unstyled dropdown-toggle-no-caret"
        :toggle-class="['header-image-upload-btn', 'text-light']"
        id="header-image-upload-btn"
        menu-class="main-color"
        no-caret>
        <BDropdownItem :button-class="['text-light', 'main-color-hover']" @click="openBookmarkModal()" v-if="loginStatus['prodInst'] !== '1'">ブックマーク</BDropdownItem>
        <BDropdownItem :button-class="['text-light', 'main-color-hover']" @click="openProductionInstructionBookmarkModal()" v-else>ブックマーク</BDropdownItem>
        <BDropdownItem :button-class="['text-light', 'main-color-hover']" @click="openImageUploadModal()" v-if="loginStatus['referenceFlag'] !== '1'">受け取る</BDropdownItem>
        <BDropdownItem :button-class="['text-light', 'main-color-hover']" @click="openUploadImageShowModal()" v-if="loginStatus['prodInst'] !== '1'">表示する</BDropdownItem>
        <BDropdownItem :button-class="['text-light', 'main-color-hover']" @click="openProductionInstructionUploadImageShowModal()" v-else>表示する</BDropdownItem>
      </BNavItemDropdown>
      <BButton
        v-if="this.consts.floristHeaderEstimateMenuShowPages.includes(this.$parent.$parent.$options.name)"
        id="estimate-trigger"
        class="ms-sm-2 ms-xl-3 header-estimate-btn"
        @click="toggleEstimate(true)">
        見積
      </BButton>
      <BButton
        v-if="this.consts.floristHeaderMemoMenuShowPages.includes(this.$parent.$parent.$options.name)"
        id="overall-memo-btn"
        class="ms-sm-2 ms-xl-3"
        @click="ownShowAndOtherbSidebarHide('sidebar-3')">
        全体メモ
      </BButton>
      <BButton
        v-if="this.consts.floristHeaderMemoMenuShowPages.includes(this.$parent.$parent.$options.name)"
        id="meeting-memo-btn"
        class="ms-sm-2 ms-xl-3"
        @click="ownShowAndOtherbSidebarHide('sidebar-4')">
        打合せメモ
      </BButton>
      <div v-if="this.consts.isOperationPossibleFloristPages.includes(this.$parent.$parent.$options.name)" class="ms-2" id="florist-control">
        <a href="javascript:void(0)" :class="[getIsOperationPossible ? 'text-light' : 'text-success disabled' , 'h3']" @click="changeIsOperationPossible()">
          <i class="bi bi-play-circle"></i>
        </a>
        <a href="javascript:void(0)" :class="[getIsOperationPossible ? 'text-danger disabled' : 'text-light', 'h3', 'ms-1']" @click="changeIsOperationPossible()">
          <i class="bi bi-pause-circle"></i>
        </a>
      </div>
      <label class="ms-3" style="color:white" v-if="loginStatus['prodInst'] !== '1'">商品金額表示:</label>
      <div class="form-check form-switch ms-1" v-if="loginStatus['prodInst'] !== '1'">
        <input type="checkbox" class="form-check-input" id="customSwitch1" v-model="customerDisplayFlag" @change="changeCustomerDisplayFlag">
        <label class="form-check-label" for="customSwitch1"></label>
      </div>
      <div id="operation-reconnect" class="ms-auto me-4">
        <a href="javascript:void(0)" :class="['text-light', 'h3', 'ms-1']" @click="meetingIdCheck()" v-if="loginStatus['prodInst'] !== '1'">
          <i class="bi bi-arrow-clockwise fs-4 text-light"></i>
        </a>
      </div>
      <div id="operation-status">
        <p class="m-0" v-if="this.consts.isShowFloristOperationStatusFloristPages.includes(this.$parent.$parent.$options.name)">
          フローリスト操作中
        </p>
        <p class="m-0" v-else>
          {{getIsOperationPossible ? 'フローリスト操作中' : 'お客様操作中'}}
        </p>
      </div>
    </nav>
    <div>
      <BOffcanvas v-model="showSidebar1" id="sidebar-1" class="sidebar offcanvas-menu ps-3" no-backdrop placement="start" style="--bs-offcanvas-width:500px; z-index:100;" no-header>
        <BOverlay :show="searchOverlayShow" rounded="sm">

          <div id="project-types">
            <div class="row mb-2 align-items-center">
              <div class="col-sm-9">
                <h5 class="text-primary mb-0">現在の打合せ内容</h5>
              </div>
            </div>
            <div class="row g-2">
              <div v-for="(typeName, index) in projectTypes" :key="'projectType' + index" :class="index === 0 ? 'col-12' : 'col-4'" class = "px-0">
                <div class="form-check d-flex align-items-start ps-0">
                  <input class="form-check-input mt-1 me-2 flex-shrink-0" type="radio" :id="'projectType' + index" name="projectType" data-param-name="projectType" :value="typeName"  @change="changeProjectType" v-model="projectType">
                  <label class="form-check-label white-space-pre-wrap mb-0" :for="'projectType' + index">{{typeName}}</label>
                </div>
              </div>
            </div>
          </div>

          <div id="search-conditions" v-if="!isProjectTypeEstimate">
            <h5 class="mt-4 text-primary">検索条件</h5>

            <div class="mt-3" id="suggestion-types" v-if="isProjectTypeMain">
              <div class="mt-3">
                  <label class="mb-1 px-0 col-12">提案区分</label>
              </div>
              <div>
                <div class="d-inline">
                  <div class="form-check form-check-inline px-0 me-0 col-6">
                    <input class="form-check-input" type="radio" id="style-suggestion" name="suggestion-type" data-param-name="suggestionType" value="style" @change="changeSuggestionType" v-model="suggestionType">
                    <label class="mb-0 ms-2" for="style-suggestion">スタイル提案</label>
                  </div>
                </div>
                <div class="d-inline">
                  <div class="form-check form-check-inline px-0 me-0 col-5">
                    <input class="form-check-input" type="radio" id="cordinate-suggestion" name="suggestion-type" data-param-name="suggestionType" value="cordinate" @change="changeSuggestionType" v-model="suggestionType">
                    <label class="mb-0 ms-2" for="cordinate-suggestion">スペック提案</label>
                  </div>
                </div>
              </div>
              <div>
                <div class="d-inline">
                  <div class="form-check form-check-inline px-0 me-0 col-6">
                    <input class="form-check-input" type="radio" id="main-option-suggestion" name="suggestion-type" data-param-name="suggestionType" value="mainopt" @change="changeSuggestionType" v-model="suggestionType">
                    <label class="mb-0 ms-2" for="main-option-suggestion">メイン／オプション提案</label>
                  </div>
                </div>
                <div class="d-inline">
                  <div class="form-check form-check-inline px-0 me-0 col-5">
                    <input class="form-check-input" type="radio" id="guest-option-suggestion" name="suggestion-type" data-param-name="suggestionType" value="guestopt" @change="changeSuggestionType" v-model="suggestionType">
                    <label class="mb-0 ms-2" style="white-space:nowrap;" for="guest-option-suggestion">ゲスト／オプション提案</label>
                  </div>
                </div>
              </div>
              <div>
                <div class="d-inline">
                  <div class="form-check form-check-inline px-0 me-0 col-6">
                    <input class="form-check-input" type="radio" id="main-suggestion" name="suggestion-type" data-param-name="suggestionType" value="main" @change="changeSuggestionType" v-model="suggestionType">
                    <label class="mb-0 ms-2" for="main-suggestion">メイン提案</label>
                  </div>
                </div>
                <div class="d-inline">
                  <div class="form-check form-check-inline px-0 me-0 col-5">
                    <input class="form-check-input" type="radio" id="guest-suggestion" name="suggestion-type" data-param-name="suggestionType" value="guest" @change="changeSuggestionType" v-model="suggestionType">
                    <label class="mb-0 ms-2" style="white-space:nowrap;" for="guest-suggestion">ゲスト提案</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-3" id="section-s" v-if="!isProjectTypeMain && !isProjectTypeEstimate">
              <div class="mt-3">
                    <label class="mb-1 px-0 col-12">小区分</label>
              </div>
              <div class="d-inline" v-for="(value, index) in conditions['sectionS']" :key="'section' + index">
                <div class="form-check form-check-inline px-0">
                  <!--<input v-if="projectType === 'ブーケ'" class="form-check-input" type="checkbox" :id="'section' + index" name="sectionS" data-param-name="sectionS" :value="value" @change="changeSectionS" v-bind="sectionS">-->
                  <input v-if="projectType === 'ブーケ'" class="form-check-input" type="checkbox" :id="'section' + index" name="sectionS" data-param-name="sectionS" :value="value" @change="changeSectionS" v-model="sectionS">
                  <input v-else class="form-check-input" type="radio" :id="'section' + index" name="sectionS" data-param-name="sectionS" :value="value" @change="changeSectionS" v-model="sectionS[0]">
                  <label class="mb-0 ms-2" :for="'section' + index">{{value}}</label>
                </div>
              </div>
            </div>

            <div v-for="(type, index) in searchTypes" :key="'search' + index">

              <div v-if="type === 'style' && (suggestionType === 'style' || suggestionType === 'cordinate' || suggestionType === 'main' || suggestionType === 'guest')" class="d-flex flex-row flex-wrap">
                <div class="mt-3 px-0 col-12">
                  <label class="mb-1">スタイル</label>
                </div>
                <div v-if="suggestionType === 'cordinate' || suggestionType === 'main' || suggestionType === 'guest'" class="form-check form-check-inline col-12 px-0">
                  <input class="form-check-input" type="checkbox" id="selectAll" :checked="isAllSelected" @click="selectAllStyle">
                  <label class="mb-0 ms-2" for="selectAll">全て選択</label>
                </div>
                <div v-if="suggestionType === 'style'" class="col-6 mx-0 px-0 d-flex flex-column">
                  <div class="d-inline" v-for="(styleData, styleNumber, index) in viewStyles" :key="'style' + styleNumber">
                    <template v-if="index < viewStylesCountMax / 2">
                      <div class="form-check form-check-inline me-0 px-0">
                        <input class="form-check-input" type="checkbox" :id="'style' + styleNumber" name="style" data-param-name="style" :value="styleData.styleName" :data-style-code="styleData.styleCode" :data-style-number="styleNumber" v-model="style">
                        <label class="mb-0 ms-2" :for="'style' + styleNumber">{{styleNumber}}:{{styleData.styleName}}</label>
                      </div>
                    </template>
                  </div>
                </div>
                <div v-else class="col-6 mx-0 px-0 d-flex flex-column">
                  <div class="d-inline" v-for="(styleData, styleNumber, index) in viewStyles" :key="'style' + styleNumber">
                    <template v-if="index < viewStylesCountMax / 2">
                      <div class="form-check form-check-inline me-0 px-0">
                        <input class="form-check-input" type="checkbox" :id="'style' + styleNumber" name="style" data-param-name="style" :value="styleData.styleName" :data-style-code="styleData.styleCode" :data-style-number="styleNumber" v-model="style" @change="select(styleData)">
                        <label class="mb-0 ms-2" :for="'style' + styleNumber">{{styleNumber}}:{{styleData.styleName}}</label>
                      </div>
                    </template>
                  </div>
                </div>
                <div v-if="suggestionType === 'style'" class="col-6 mx-0 px-0 d-flex flex-column">
                  <div class="d-inline" v-for="(styleData, styleNumber, index) in viewStyles" :key="'style' + styleNumber">
                    <template v-if="index >= viewStylesCountMax / 2">
                      <div class="form-check form-check-inline me-0 px-0">
                        <input class="form-check-input" type="checkbox" :id="'style' + styleNumber" name="style" data-param-name="style" :value="styleData.styleName" :data-style-code="styleData.styleCode" :data-style-number="styleNumber" v-model="style">
                        <label class="mb-0 ms-2" :for="'style' + styleNumber">{{styleNumber}}:{{styleData.styleName}}</label>
                      </div>
                    </template>
                  </div>
                </div>
                <div v-else class="col-6 mx-0 px-0 d-flex flex-column">
                  <div class="d-inline" v-for="(styleData, styleNumber, index) in viewStyles" :key="'style' + styleNumber">
                    <template v-if="index >= viewStylesCountMax / 2">
                      <div class="form-check form-check-inline me-0 px-0">
                        <input class="form-check-input" type="checkbox" :id="'style' + styleNumber" name="style" data-param-name="style" :value="styleData.styleName" :data-style-code="styleData.styleCode" :data-style-number="styleNumber" v-model="style" @change="select(styleData)">
                        <label class="mb-0 ms-2" :for="'style' + styleNumber">{{styleNumber}}:{{styleData.styleName}}</label>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <div v-if="type === 'main-table-types' && isProjectTypeMain && (suggestionType === 'cordinate' || suggestionType === 'main')">
                <div class="mt-3">
                    <label class="mb-1 px-0 col-12">メインテーブルタイプ</label>
                </div>
                <div>
                  <div class="d-inline">
                    <div class="form-check form-check-inline px-0">
                      <input class="form-check-input" type="radio" id="nashi-main-table" name="mainSectionS" data-param-name="mainSectionS" value="" v-model="mainSectionS">
                      <label class="mb-0 ms-2" for="nashi-main-table">指定なし</label>
                    </div>
                  </div>
                  <div class="d-inline">
                    <div class="form-check form-check-inline px-0">
                      <input class="form-check-input" type="radio" id="takasa-main-table" name="mainSectionS" data-param-name="mainSectionS" value="メインテーブルフラワー(高砂)" v-model="mainSectionS">
                      <label class="mb-0 ms-2" for="takasa-main-table">高砂</label>
                    </div>
                  </div>
                  <div class="d-inline">
                    <div class="form-check form-check-inline px-0">
                      <input class="form-check-input" type="radio" id="sofa-main-table" name="mainSectionS" data-param-name="mainSectionS" value="メインテーブルフラワー(ソファ)" v-model="mainSectionS">
                      <label class="mb-0 ms-2" style="white-space:nowrap;" for="sofa-main-table">ソファ</label>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="type === 'guest-table-types' && isProjectTypeMain && (suggestionType === 'cordinate' || suggestionType === 'guest')">
                <div class="mt-3">
                    <label class="mb-1 ms-2 px-0 col-12">ゲストテーブルタイプ</label>
                </div>
                <div>
                  <div class="d-inline">
                    <div class="form-check form-check-inline px-0">
                      <input class="form-check-input" type="radio" id="nashi-guest-table" name="guestSectionS" data-param-name="guestSectionS" value="" v-model="guestSectionS">
                      <label class="mb-0 ms-2" for="nashi-guest-table">指定なし</label>
                    </div>
                  </div>
                  <div class="d-inline">
                    <div class="form-check form-check-inline px-0">
                      <input class="form-check-input" type="radio" id="entaku-guest-table" name="guestSectionS" data-param-name="guestSectionS" value="ゲストテーブルフラワー" v-model="guestSectionS">
                      <label class="mb-0 ms-2" for="entaku-guest-table">円卓</label>
                    </div>
                  </div>
                  <div class="d-inline">
                    <div class="form-check form-check-inline px-0">
                      <input class="form-check-input" type="radio" id="nagashi-guest-table" name="guestSectionS" data-param-name="guestSectionS" value="ゲストテーブルフラワー(流し卓)" v-model="guestSectionS">
                      <label class="mb-0 ms-2" style="white-space:nowrap;" for="nagashi-guest-table">流し</label>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="type === 'style' && suggestionType === 'mainopt'" class="d-flex flex-row flex-wrap">
                <div class="mt-3">
                  <label class="mb-1 px-0 col-12">小区分</label>
                </div>
                <div>
                  <div class="d-inline" v-for="(value, index) in conditions['mainoptSectionS']" :key="'mainoptSectionS' + index">
                    <div class="form-check form-check-inline px-0">
                      <input class="form-check-input" type="radio" :id="'mainoptSectionS' + index" name="mainoptSectionS" data-param-name="mainoptSectionS" :value="value" v-model="mainoptSectionS">
                      <label class="mb-0 ms-2" :for="'mainoptSectionS' + index">{{value}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="type === 'style' && suggestionType === 'guestopt'" class="d-flex flex-row flex-wrap">
                <div class="mt-3">
                  <label class="mb-1 px-0 col-12">小区分</label>
                </div>
                <div>
                  <div class="d-inline" v-for="(value, index) in conditions['guestoptSectionS']" :key="'guestoptSectionS' + index">
                    <div class="form-check form-check-inline px-0">
                      <input class="form-check-input" type="radio" :id="'guestoptSectionS' + index" name="guestoptSectionS" data-param-name="guestoptSectionS" :value="value" v-model="guestoptSectionS">
                      <label class="mb-0 ms-2" :for="'guestoptSectionS' + index">{{value}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="type === 'season'">
                <div class="mt-3">
                  <label class="mb-1">季節</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="seasonCheck0" name="season" data-param-name="season" value="" v-model="season">
                  <label class="mb-0 ms-2" for="seasonCheck0">指定なし</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="seasonCheck1" name="season" data-param-name="season" value="通年" v-model="season">
                  <label class="mb-0 ms-2" for="seasonCheck1">通年</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="seasonCheck2" name="season" data-param-name="season" value="春花材" v-model="season">
                  <label class="mb-0 ms-2" for="seasonCheck2">春花材</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="seasonCheck3" name="season" data-param-name="season" value="初夏花材" v-model="season">
                  <label class="mb-0 ms-2" for="seasonCheck3">初夏花材</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="seasonCheck4" name="season" data-param-name="season" value="夏花材" v-model="season">
                  <label class="mb-0 ms-2" for="seasonCheck4">夏花材</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="seasonCheck5" name="season" data-param-name="season" value="秋花材" v-model="season">
                  <label class="mb-0 ms-2" for="seasonCheck5">秋花材</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="seasonCheck6" name="season" data-param-name="season" value="冬花材" v-model="season">
                  <label class="mb-0 ms-2" for="seasonCheck6">冬花材</label>
                </div>
              </div>

              <div v-if="type === 'mainGuestSeason'">
                <div class="mt-3">
                  <label class="mb-1">季節</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="mainGuestSeasonCheck0" name="mainGuestSeason" data-param-name="mainGuestSeason" value="" v-model="season">
                  <label class="mb-0 ms-2" for="mainGuestSeasonCheck0">指定なし</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="mainGuestSeasonCheck1" name="mainGuestSeason" data-param-name="mainGuestSeason" value="通年" v-model="season">
                  <label class="mb-0 ms-2" for="mainGuestSeasonCheck1">通年</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="mainGuestSeasonCheck2" name="mainGuestSeason" data-param-name="mainGuestSeason" value="春花材" v-model="season">
                  <label class="mb-0 ms-2" for="mainGuestSeasonCheck2">春花材</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="mainGuestSeasonCheck3" name="mainGuestSeason" data-param-name="mainGuestSeason" value="初夏花材" v-model="season">
                  <label class="mb-0 ms-2" for="mainGuestSeasonCheck3">初夏花材</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="mainGuestSeasonCheck4" name="mainGuestSeason" data-param-name="mainGuestSeason" value="夏花材" v-model="season">
                  <label class="mb-0 ms-2" for="mainGuestSeasonCheck4">夏花材</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="mainGuestSeasonCheck5" name="mainGuestSeason" data-param-name="mainGuestSeason" value="秋花材" v-model="season">
                  <label class="mb-0 ms-2" for="mainGuestSeasonCheck5">秋花材</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="mainGuestSeasonCheck6" name="mainGuestSeason" data-param-name="mainGuestSeason" value="冬花材" v-model="season">
                  <label class="mb-0 ms-2" for="mainGuestSeasonCheck6">冬花材</label>
                </div>
              </div>

              <div v-if="type === 'color'">
                <div class="mt-3">
                  <label class="mb-1">色</label>
                </div>
                <div class="d-inline" v-for="(value, index) in conditions['colors']" :key="'color' + index">
                  <div class="form-check form-check-inline me-0 px-0 col-3">
                    <input class="form-check-input" type="checkbox" :id="'colorCheck' + index" name="color" data-param-name="color" :value="value" v-model="color">
                    <label class="mb-0 ms-2" :for="'colorCheck' + index">{{value}}</label>
                  </div>
                </div>
              </div>

              <div v-if="type === 'mainShape'" class="mt-3">
                <div class="mt-3 px-0 col-12">
                  <label class="mb-1">メイン形状</label>
                </div>
                <div>
                  <v-select id="mainShape-date" v-model="mainShape" label="label" :options="conditions['mainShapes']" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple></v-select>
                </div>
              </div>

              <div v-if="type === 'guestShape'" class="mt-3">
                <div class="mt-3 px-0 col-12">
                  <label class="mb-1">ゲスト形状</label>
                </div>
                <div>
                  <v-select id="guestShape-date" v-model="guestShape" label="label" :options="conditions['guestShapes']" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple></v-select>
                </div>
              </div>

              <div v-if="type === 'shape'">
                <div class="mt-3">
                  <label class="mb-1">形</label>
                </div>
                <div class="d-inline" v-for="(value, index) in conditions['shapes']" :key="'shape' + index">
                  <div class="form-check form-check-inline px-0">
                    <input class="form-check-input" type="radio" :id="'shapeCheck' + index" name="shape" data-param-name="shape" :value="value" v-model="shape">
                    <label class="mb-0 ms-2" :for="'shapeCheck' + index">{{value}}</label>
                  </div>
                </div>
              </div>

              <div v-if="type === 'figure'">
                <div class="mt-3">
                  <label class="mb-1">形態</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="figureCheck" name="figure" data-param-name="figure" value="" v-model="figure">
                  <label class="mb-0 ms-2" for="figureCheck">指定なし</label>
                </div>
                <div class="d-inline" v-for="(value, index) in conditions['figures']" :key="'figure' + index">
                  <div class="form-check form-check-inline px-0">
                    <input class="form-check-input" type="radio" :id="'figureCheck' + index" name="figure" data-param-name="figure" :value="value" v-model="figure">
                    <label class="mb-0 ms-2" :for="'figureCheck' + index">{{value}}</label>
                  </div>
                </div>
              </div>

              <div v-if="type === 'mainPrice'">
                <div class="mt-3">
                  <label class="mb-1">メインテーブル価格</label>
                </div>
                <div class="row">
                  <div class="col-5">
                    <input type="text" name="mainPriceFrom" id="mainPriceFrom" data-param-name="mainPriceFrom" class="form-control" v-model="mainPriceFrom">
                    <i class="bi bi-x clear-form fs-4" @click="mainPriceFrom = ''" v-if="mainPriceFrom !== ''"></i>
                  </div>
                  <span class="col-1 p-0 pt-2 text-center">〜</span>
                  <div class="col-5">
                    <input type="text" name="mainPriceTo" id="mainPriceTo" data-param-name="mainPriceTo" class="form-control" v-model="mainPriceTo">
                    <i class="bi bi-x clear-form fs-4" @click="mainPriceTo = ''" v-if="mainPriceTo !== ''"></i>
                  </div>
                </div>
              </div>

              <div v-if="type === 'guestPrice'">
                <div class="mt-3">
                  <label class="mb-1">ゲストテーブル価格</label>
                </div>
                <div class="row">
                  <div class="col-5">
                    <input type="text" name="guestPriceFrom" id="guestPriceFrom" data-param-name="guestPriceFrom" class="form-control" v-model="guestPriceFrom">
                    <i class="bi bi-x clear-form fs-4" @click="guestPriceFrom = ''" v-if="guestPriceFrom !== ''"></i>
                  </div>
                  <span class="col-1 p-0 pt-2 text-center">〜</span>
                  <div class="col-5">
                    <input type="text" name="guestPriceTo" id="guestPriceTo" data-param-name="guestPriceTo" class="form-control" v-model="guestPriceTo">
                    <i class="bi bi-x clear-form fs-4" @click="guestPriceTo = ''" v-if="guestPriceTo !== ''"></i>
                  </div>
                </div>
              </div>

              <div v-if="type === 'price'">
                <div class="mt-3">
                  <label class="mb-1">価格</label>
                </div>
                <div class="row">
                  <div class="col-5">
                    <input type="text" name="priceFrom" id="priceFrom" data-param-name="priceFrom" class="form-control" v-model="priceFrom">
                    <i class="bi bi-x clear-form fs-4" @click="priceFrom = ''" v-if="priceFrom !== ''"></i>
                  </div>
                  <span class="col-1 p-0 pt-2 text-center">〜</span>
                  <div class="col-5">
                    <input type="text" name="priceTo" id="priceTo" data-param-name="priceTo" class="form-control" v-model="priceTo">
                    <i class="bi bi-x clear-form fs-4" @click="priceTo = ''" v-if="priceTo !== ''"></i>
                  </div>
                </div>
              </div>

              <div v-if="type === 'cordinateMaker'">
                <div class="mt-3">
                  <label class="mb-1">メーカー</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="cordinateMakerCheck" name="cordinateMaker" data-param-name="cordinateMaker" value="" v-model="cordinateMaker">
                  <label class="mb-0 ms-2" for="cordinateMakerCheck">指定なし</label>
                </div>
                <div class="d-inline" v-for="(value, index) in conditions['cordinateMakers']" :key="'cordinateMaker' + index">
                  <div class="form-check form-check-inline px-0">
                    <input class="form-check-input" type="radio" :id="'cordinateMakerCheck' + index" name="cordinateMaker" data-param-name="cordinateMaker" :value="value" v-model="cordinateMaker">
                    <label class="mb-0 ms-2" :for="'cordinateMakerCheck' + index">{{value}}</label>
                  </div>
                </div>
              </div>

              <div v-if="type === 'afterBouquetMaker'">
                <div class="mt-3">
                  <label class="mb-1">メーカー</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="afterBouquetMakerCheck" name="afterBouquetMaker" data-param-name="afterBouquetMaker" value="" v-model="afterBouquetMaker">
                  <label class="mb-0 ms-2" for="afterBouquetMakerCheck">指定なし</label>
                </div>
                <div class="d-inline" v-for="(value, index) in conditions['afterBouquetMakers']" :key="'afterBouquetMaker' + index">
                  <div class="form-check form-check-inline px-0">
                    <input class="form-check-input" type="radio" :id="'afterBouquetMakerCheck' + index" name="afterBouquetMaker" data-param-name="afterBouquetMaker" :value="value" v-model="afterBouquetMaker">
                    <label class="mb-0 ms-2" :for="'afterBouquetMakerCheck' + index">{{value}}</label>
                  </div>
                </div>
              </div>

              <div v-if="type === 'facilityType'">
                <div class="mt-3">
                  <label class="mb-1">施設区分</label>
                </div>
                <div class="d-inline">
                  <div class="form-check form-check-inline px-0">
                    <input class="form-check-input" type="radio" id="facilityType0" name="facilityType" data-param-name="facilityType" value="" v-model="facilityType">
                    <label class="mb-0 ms-2" for="facilityType0">指定なし</label>
                  </div>
                </div>
                <div class="d-inline" v-for="(value, index) in conditions['facilityTypes']" :key="'shape' + index">
                  <div class="form-check form-check-inline px-0">
                    <input class="form-check-input" type="radio" :id="'facilityType' + index" name="facilityType" data-param-name="facilityType" :value="value" v-model="facilityType">
                    <label class="mb-0 ms-2" :for="'facilityType' + index">{{value}}</label>
                  </div>
                </div>
              </div>

              <div v-if="type === 'facilityCode'">
                <div class="mt-3">
                  <label class="mb-1">施設コード</label>
                </div>
                <div class="row">
                  <div class="col-5">
                    <input type="text" name="facilityCode" id="facilityCode" data-param-name="facilityCode" class="form-control" v-model="facilityCode">
                    <i class="bi bi-x clear-form fs-4" @click="facilityCode = ''" v-if="facilityCode !== ''"></i>
                  </div>
                </div>
              </div>
              <div v-if="type === 'coreProduct'">
                <div class="mt-3">
                  <label for="coreProductCheck" class="mb-1">注力商品のみ表示する</label>
                </div>
                <input class="form-check-input" type="checkbox" id="coreProductCheck" name="coreProduct" data-param-name="coreProduct" v-model="coreProduct">
              </div>
              <div v-if="type === 'normalCoreProduct'">
                <div class="mt-3">
                  <label for="coreProductCheck" class="mb-1">注力商品のみ表示する</label>
                </div>
                <input class="form-check-input" type="checkbox" id="coreProductCheck" name="normalCoreProduct" data-param-name="normalCoreProduct" v-model="normalCoreProduct">
              </div>
              <div v-if="type === 'facilitySpecific'">
                <div class="mt-5">
                  <label for="facilitySpecificCheck" class="mb-1">施設特有のみ表示する</label>
                </div>
                <input class="form-check-input" type="checkbox" id="facilitySpecificCheck" name="facilitySpecific" data-param-name="facilitySpecific" v-model="facilitySpecific">
              </div>

              <div v-if="type === 'shisetsu'">
                <div class="mt-3">
                  <label class="mb-1">施設特有商品</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="shisetsuCheck0" name="shisetsu" data-param-name="shisetsu" value="" v-model="shisetsu">
                  <label class="mb-0 ms-2" for="shisetsuCheck0">全て</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="shisetsuCheck1" name="shisetsu" data-param-name="shisetsu" value="施設特有以外" v-model="shisetsu">
                  <label class="mb-0 ms-2" for="shisetsuCheck1">施設特有以外</label>
                </div>
                <div class="form-check form-check-inline px-0">
                  <input class="form-check-input" type="radio" id="shisetsuCheck2" name="shisetsu" data-param-name="shisetsu" value="施設特有のみ" v-model="shisetsu">
                  <label class="mb-0 ms-2" for="shisetsuCheck2">施設特有のみ</label>
                </div>
              </div>

            </div>
          </div>

          <template v-if="isJumpPage">
            <div class="my-5 d-flex justify-content-around" v-if="isProjectTypeMain">
              <BButton variant="btn-outline-primary" class="sub-button-color" @click="closeMenu">閉じる</BButton>
              <BButton variant="primary" @click="mainGuestSuggestion">提案する</BButton>
            </div>
            <div class="my-5 d-flex justify-content-around" v-else-if="isProjectTypeEstimate">
              <BButton variant="btn-outline-primary" class="sub-button-color" @click="closeMenu">閉じる</BButton>
              <BButton variant="primary" class="me-3" @click="estimate">見積を表示する</BButton>
            </div>
            <div class="my-5 d-flex justify-content-around" v-else>
              <BButton variant="btn-outline-primary" class="sub-button-color" @click="closeMenu">閉じる</BButton>
              <BButton variant="primary" @click="itemSuggestion">提案する</BButton>
            </div>
          </template>
          <template v-else>
            <div class="my-5 d-flex justify-content-around">
              <BButton variant="btn-outline-primary" class="sub-button-color" @click="closeMenu">閉じる</BButton>
            </div>
          </template>

          <CommonModal ref="commonModal" />
          <ImageUploadModal ref="imageUploadModal" @signalingModalChangeEvent="signalingModalChangeSend" :cookieProjectNumber="cookieProjectNumber" />
          <UploadImageShowModal ref="uploadImageShowModal" @signalingModalChangeEvent="signalingModalChangeSend" @goToProductSelection="goToProductSelection" @cookieProjectNumberCheck="cookieProjectNumberCheck" :cookieProjectNumber="cookieProjectNumber" />
          <ProductionInstructionUploadImageShowModal ref="productionInstructionUploadImageShowModal" @signalingModalChangeEvent="signalingModalChangeSend" @goToProductionInstruction="goToProductionInstruction" :cookieProjectNumber="cookieProjectNumber" />
          <BookmarkModal ref="bookmarkModal" @signalingModalChangeEvent="signalingModalChangeSend" @goToProductSelection="goToProductSelection" @cookieProjectNumberCheck="cookieProjectNumberCheck" @goToProductSelectionFromBookmark="goToProductSelectionFromBookmark" :cookieProjectNumber="cookieProjectNumber" />
          <ProductionInstructionBookmarkModal ref="productionInstructionBookmarkModal" @signalingModalChangeEvent="signalingModalChangeSend" @goToProductionInstruction="goToProductionInstruction" @cookieProjectNumberCheck="cookieProjectNumberCheck" @goToProductSelectionFromBookmark="goToProductSelectionFromBookmark" :cookieProjectNumber="cookieProjectNumber" />
          <MainGuestImageDisplayModal ref="mainGuestImageDisplayModal" @signalingModalChangeEvent="signalingModalChangeSend" @setMainGuestImageDisplayData="setMainGuestImageDisplayData"
          :mainGuestImageDisplayData="mainGuestImageDisplayData"/>
          <MainGuestProdInstImageDisplayModal ref="mainGuestProdInstImageDisplayModal" @signalingModalChangeEvent="signalingModalChangeSend" @setMainGuestProdInstImageDisplayData="setMainGuestProdInstImageDisplayData"
          :mainGuestProdInstImageDisplayData="mainGuestProdInstImageDisplayData"/>
        </BOverlay>
      </BOffcanvas>

      <BOffcanvas v-model="showSidebar2" class="sidebar p-4" id="sidebar-2" no-backdrop placement="end" style="--bs-offcanvas-width:1250px; z-index:100;" no-header>
        <BOverlay :show="estimateOverlayShow" rounded="sm">
          <BButton class="position-absolute me-2 d-inline estimate-menu-button" @click="estimate" v-if="loginStatus['prodInst'] !== '1'">見積表示する(お客様へ)</BButton>
          <div v-else class="row col-sm-12">
            <div class="mt-3 text-end col-sm-9">
              制作担当：
              <select class="me-4" style="width: 28%" v-model="prodBaseName" :disabled="prodBaseAndOpPtnDisabledFlag">
                <option v-for="pBName in prodBaseOptions" v-bind:key="pBName">{{pBName}}</option>
              </select>
              <div class="numeric-errors small" style="margin-right: 10.5rem" id="prodBaseErrElem"></div>
            </div>
            <div class="mt-3 text-end col-sm-3">
              委託有無：
              <select style="width: 65%" v-model="operationPtnName" :disabled="prodBaseAndOpPtnDisabledFlag">
                <option v-for="opName in operationPtnOptions" v-bind:key="opName">{{opName}}</option>
              </select>
              <div class="numeric-errors small" style="margin-right: 5rem" id="operationPtnErrElem"></div>
            </div>
          </div>
          <!--<BButton class="mt-3 d-inline estimate-menu-button" @click="openAddEstimateItemModal()">商品を追加</BButton>-->
            <div class="mt-3 text-end">
            プラン：
            <select class="w-20 me-4" v-model="planEstimateData">
                <option v-for="planName in planOptions" v-bind:key="planName">{{planName}}</option>
            </select>
            パック：
            <select class="w-20 me-4" v-model="packEstimateData">
                <option v-for="packName in packOptions" v-bind:key="packName">{{packName}}</option>
            </select>
            <div class="numeric-errors small" style="margin-right: 7.5rem!important" id="packErrElem"></div>
            </div>
          <div class="text-end mt-3">
            <div>
              人数：
              <input class="w-5 me-3 text-end" type="text" name="attendance" id="attendance" v-model="attendanceUpdateData">
              名
            </div>
            <div class="numeric-errors small" id="attendanceErrElem"></div>
          </div>
          <table class="table table-bordered small text-center estimate-table mt-3" id="estimate-table">
            <thead class="thead-light">
              <tr>
                <th style="width: 4%" v-if="loginStatus['prodInst'] !== '1'">手描き編集</th>
                <th style="width: 7%"></th>
                <th style="width: 7%">中区分</th>
                <th style="width: 7%">小区分</th>
                <th style="width: 4%" v-if="loginStatus['prodInst'] !== '1'">小区分<br>まとめ</th>
                <th style="width: 9%">商品名</th>
                <th style="width: 7%">パック<br>単価</th>
                <th style="width: 4%">パック<br>数量</th>
                <th style="width: 4%">パック<br>割引率</th>
                <th style="width: 7%">商品単価<br>(税抜)</th>
                <th style="width: 7%">差額単価</th>
                <th style="width: 4%">割引(%)</th>
                <th style="width: 4%">数量</th>
                <th style="width: 7%" v-if="hasPack">差額合計</th>
                <th style="width: 7%" v-else>商品金額計<br>(税抜)</th>
                <th style="width: 7%">備考</th>
                <th style="width: 4%">変更</th>
                <th style="width: 4%" v-if="loginStatus['prodInst'] !== '1' && loginStatus['afterMTG'] === '1'">コミッション</th>
                <th style="width: 4%" v-if="loginStatus['prodInst'] === '1'">SDP<br>委託率</th>
                <th style="width: 4%" v-if="loginStatus['prodInst'] !== '1'"></th>
                <th style="width: 4%" v-if="loginStatus['prodInst'] !== '1'">削除</th>
                <th style="width: 4%">画像見積表示</th>
                <th style="width: 4%" v-if="loginStatus['prodInst'] === '1'">制作指示に表示</th>
                <th style="width: 4%" v-if="loginStatus['prodInst'] === '1'">制作指示手描き</th>
              </tr>
            </thead>
            <tbody>
              <input type="hidden" name="category" value="メインテーブル・ゲストテーブル">
              <tr :id="estimate['items']['id']" v-for="(estimate, key, index) in mainGuestEstimateData" :key="key">
                <input type="hidden" name="tableId" :value="estimate['items']['id']">
                <td class="align-middle" :rowspan="mainRowCount + guestRowCount" v-if="estimate['mainGuestIndex'] === 0 && loginStatus['prodInst'] !== '1'">
                  <span :class="loginStatus['prodInst'] !== '1' ? 'border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn' : 'border border-dark rounded-circle d-inline-flex align-items-center justify-content-center text-black-50 btn'" style="width: 30px;height: 30px;"
                  @click="goToProductSelection(mainGuestProjectNumber, 'メインテーブル・ゲストテーブル', estimate['items']['id'], 'cordinate')">
                    <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                  </span>
                </td>
                <td
                  class="align-middle"
                  :rowspan="key === 'メインテーブル0' ? mainRowCount : guestRowCount"
                  v-if="key === 'メインテーブル0' || key === 'ゲストテーブル0'"
                >{{estimate['items']['sectionL']}}</td>
                <td>{{estimate['items']['sectionM']}}</td>
                <td @click="sectionSClick('mainGuestSectionS' + index, estimate['items']['sectionL'], estimate['items']['sectionM'], $event)">
                  <u style="color: blue;">{{estimate['items']['sectionS']}}</u>
                  <input type="text" name="setSectionS" v-model="estimate['items']['sectionS']" hidden>
                  <div class="sectionS-menu-close" :id="'mainGuestSectionSClose' + index">
                    <li class="sectionS-menu">
                    ×
                    </li>
                  </div>
                  <div class="sectionS-menu-board" :id="'mainGuestSectionS' + index">
                    <ul style= "padding: 0px 0px 0px 0px; margin: 0;" v-for="(ssdata, index2) in EstimateSectionSData" v-bind:key="ssdata + index2">
                      <li :style= "estimate['items']['sectionS'] === ssdata ? 'background-color:#DDEEFF;' : ''" class="sectionS-menu" @click="sectionSMenuClick('mainGuest', key, 'items', ssdata)">{{ssdata}}</li>
                    </ul>
                  </div>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1'">
                  <input name="compileCheckbox" :id="'checkbox-compile-' + estimate['items']['id']" type="checkbox" :checked="estimate['items']['compileEstimate']" :value="JSON.stringify({'id': 'checkbox-compile-' + estimate['items']['id'], 'itemCode': estimate['items']['itemCode'], 'category': 'メインテーブル・ゲストテーブル', 'serialNo': ''})" :disabled="loginStatus['prodInst'] === '1'">
                </td>
                <td>
                  <textarea
                    class="form-control w-100 item-note"
                    name="itemName"
                    :id="'mainGuestItemName' + index"
                    rows="1"
                    maxlength="50"
                    v-model="estimate['items']['itemName']"
                    :disabled="(!estimate['items']['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'"
                    style="overflow:hidden"
                  ></textarea>
                  <div class="numeric-errors"></div>
                </td>
                <td>
                  <input class="w-100 text-end" type="text" name="packPrice" :id="'mainGuestPackPrice' + index" v-model="estimate['items']['packPrice']" :disabled="(!estimate['items']['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td class="text-end">
                  <input class="w-100 text-end" type="text" name="packQuantity" :id="'mainGuestPackQuantity' + index" v-model="estimate['items']['packQuantity']" :disabled="(!estimate['items']['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                  <!--{{estimate['items']['packQuantity']}}-->
                </td>
                <td class="text-end">
                  <input class="w-70 text-end" type="text" name="packDiscount" :id="'mainGuestPackDiscount' + index" v-model="estimate['items']['packDiscount']" :disabled="(!estimate['items']['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <span v-if="estimate['items']['packDiscount']">%</span>
                  <div class="numeric-errors"></div>
                </td>
                <td>
                  <input class="w-100 text-end" type="text" name="itemPrice" :id="'mainGuestItemPrice' + index" v-model="estimate['items']['itemPrice']" :disabled="(!estimate['items']['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td class="text-end">{{toCommaSeparated(estimate['items']['margin'])}}</td>
                <!--<td class="text-end">{{estimate['items']['discount'] !== undefined ? estimate['items']['discount'] + '%' : ''}}</td>-->
                <td>
                  <input class="w-100 text-end" type="text" name="discount" :id="'mainGuestDiscount' + index" v-model="estimate['items']['discount']" :disabled="(!estimate['items']['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td>
                  <input class="w-100 text-end" type="text" name="quantity" :id="'mainGuestQuantity' + index" v-model="estimate['items']['quantity']" :disabled="(!estimate['items']['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td class="text-end">{{toCommaSeparated(estimate['items']['itemEstimatePriceTotal'])}}</td>
                <td>
                  <textarea
                    class="form-control w-100 item-note"
                    name="note"
                    :id="'mainGuestNote' + index"
                    rows="2"
                    maxlength="50"
                    v-model="estimate['items']['note']"
                    :disabled="(!estimate['items']['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'"
                    style="overflow:hidden"
                  ></textarea>
                </td>
                <td>
                  <input type="checkbox" value="1" name="change" :id="'mainGuestChange' + index" :checked="!estimate['items']['change'] ? false : true" @change="disableInput(index, true)" v-if="loginStatus['afterMTG'] === '1'">
                  <div v-if="loginStatus['afterMTG'] !== '1' && estimate['items']['change']">★</div>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1' && loginStatus['afterMTG'] === '1'">
                  <input class="w-100 text-end" type="text" name="commission" :id="'mainGuestCommission' + index" v-model="estimate['items']['commission']">
                  <div class="numeric-errors"></div>
                </td>
                <td v-if="loginStatus['prodInst'] === '1'">
                  <input class="w-100 text-end" type="text" name="sdpRate" :id="'mainGuestSdpRate' + index" v-model="estimate['items']['sdpRate']">
                  <div class="numeric-errors"></div>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1'">
                  <span :class="loginStatus['prodInst'] !== '1' ? 'btn p-1' : 'btn p-1 text-black-50'" @click="duplicateEstimate(estimate['items']['id'], 'メインテーブル・ゲストテーブル')">
                    <i class="bi bi-clipboard-plus"></i>
                  </span>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1'">
                  <input name="deleteCheckbox" type="checkbox" :value="JSON.stringify({'tableId': estimate['items']['id'], 'itemCode': estimate['items']['itemCode'], 'category': 'メインテーブル・ゲストテーブル'})" :disabled="loginStatus['prodInst'] === '1'">
                </td>
                <td :rowspan="mainRowCount + guestRowCount" v-if="estimate['mainGuestIndex'] === 0">
                  <i
                    class="bi bi-box-arrow-up-left"
                    :class="loginStatus['prodInst'] !== '1' ? 'text-primary' : 'text-muted'"
                    @click="handleIconClick"
                    style="font-size: 1.5rem; cursor: pointer;"
                  ></i>
                </td>
                <td :rowspan="mainRowCount + guestRowCount" v-if="estimate['mainGuestIndex'] === 0 && loginStatus['prodInst'] === '1'">
                  <i
                    class="bi bi-box-arrow-up-left text-primary"
                    @click="handleProdInstIconClick"
                    style="font-size: 1.5rem; cursor: pointer;"
                  ></i>
                </td>
                <td class="align-middle" :rowspan="mainRowCount + guestRowCount" v-if="estimate['mainGuestIndex'] === 0 && loginStatus['prodInst'] === '1'">
                  <span class="border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn" @click="goToProductionInstruction(mainGuestProjectNumber, 'メインテーブル・ゲストテーブル', estimate['items']['id'], 'cordinate')" style="width: 30px;height: 30px;">
                    <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                  </span>
                </td>
              </tr>
            </tbody>

            <!-- メインオプション・ゲストオプション -->
            <tbody v-for="(estimate, category) in mainGuestOptionData" :key="category">
              <input type="hidden" name="category" value="メインテーブル・ゲストテーブル">
              <tr :id="item['id']" v-for="(item, index) in estimate" :key="index" >
                <input type="hidden" name="itemCode" :value="item['itemCode']">
                <input type="hidden" name="tableId" :value="item['id']">
                <td class="align-middle" v-if="loginStatus['prodInst'] !== '1'">
                  <span
                    :class="loginStatus['prodInst'] !== '1' ? 'border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn' : 'border border-dark rounded-circle d-inline-flex align-items-center justify-content-center text-black-50 btn'"
                    style="width: 30px;height: 30px;"
                    @click="goToProductSelection(item['itemCode'], 'メインテーブル・ゲストテーブル', item['id'], item['sectionM'] === 'メインオプション' ? 'mainopt' : 'guestopt')"
                    v-if="'itemCode' in item">
                    <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                  </span>
                </td>
                <td class="align-middle" :rowspan="Object.keys(estimate).length" v-if="index === 0">{{item['sectionL']}}</td>
                <td>{{item['sectionM']}}</td>
                <td @click="sectionSClick('mainGuestOptionSectionS' + (category === 'メインテーブル' ? 'M' : '') + index, item['sectionL'], item['sectionM'], $event)">
                  <u style="color: blue;">{{item['sectionS']}}</u>
                  <input type="text" name="setSectionS" v-model="item['sectionS']" hidden>
                  <div class="sectionS-menu-close" :id="'mainGuestOptionSectionSClose' + (category === 'メインテーブル' ? 'M' : '') + index">
                    <li class="sectionS-menu">
                    ×
                    </li>
                  </div>
                  <div class="sectionS-menu-board" :id="'mainGuestOptionSectionS' + (category === 'メインテーブル' ? 'M' : '') + index">
                    <ul style= "padding: 0px 0px 0px 0px; margin: 0;" v-for="(ssdata, index2) in EstimateSectionSData" v-bind:key="ssdata + index2">
                      <li :style= "item['sectionS'] === ssdata ? 'background-color:#DDEEFF;' : ''" class="sectionS-menu" @click="sectionSMenuClick('mainGuestOption', category, index, ssdata)">{{ssdata}}</li>
                    </ul>
                  </div>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1'">
                  <input name="compileCheckbox" :id="'checkbox-compile-' + item['id']" type="checkbox" :checked="item['compileEstimate']" :value="JSON.stringify({'id': 'checkbox-compile-' + item['id'], 'itemCode': item['itemCode'], 'category': 'メインゲストオプション別種', 'serialNo': item['serialNo']})" :disabled="loginStatus['prodInst'] === '1'">
                </td>
                <td>
                  <textarea
                    class="form-control w-100 item-note"
                    name="itemName"
                    rows="1"
                    maxlength="50"
                    v-model="item['itemName']"
                    :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'"
                    style="overflow:hidden"
                  ></textarea>
                  <div class="numeric-errors"></div>
                </td>
                <!--<td class="text-end" v-if="hasPack">{{toCommaSeparated(item['packPrice'])}}</td>-->
                <td>
                  <input class="w-100 text-end" type="text" name="packPrice" v-model="item['packPrice']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td class="text-end">
                  <input class="w-100 text-end" type="text" name="packQuantity" v-model="item['packQuantity']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td class="text-end">
                  <input class="w-70 text-end" type="text" name="packDiscount" v-model="item['packDiscount']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <span v-if="item['packDiscount']">%</span>
                  <div class="numeric-errors"></div>
                </td>

                <td>
                  <input class="w-100 text-end" type="text" name="itemPrice" v-model="item['itemPrice']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td class="text-end">{{toCommaSeparated(item['margin'])}}</td>
                <!--<td class="text-end">{{item['discount'] ? item['discount'] + '%' : ''}}</td>-->
                <td>
                  <input class="w-100 text-end" type="text" name="discount" v-model="item['discount']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td>
                  <input class="w-100 text-end" type="text" name="quantity" v-model="item['quantity']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>

                <td class="text-end">{{toCommaSeparated(item['itemEstimatePriceTotal'])}}</td>
                <td>
                  <textarea
                    class="form-control w-100 item-note"
                    name="note"
                    rows="2"
                    maxlength="50"
                    v-model="item['note']"
                    :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'"
                    style="overflow:hidden"
                  ></textarea>
                </td>
                <td>
                  <input type="checkbox" value="1" name="change" :id="'mainGuestOptionChange' + (category === 'メインテーブル' ? 'M' : '') + index" :checked="item['change']" @change="changeRowDisabled" v-if="loginStatus['afterMTG'] === '1'">
                  <div v-if="loginStatus['afterMTG'] !== '1' && item['change'] === '1'">★</div>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1' && loginStatus['afterMTG'] === '1'">
                  <input class="w-100 text-end" type="text" name="commission" :id="'commission' + index" v-model="item['commission']">
                  <div class="numeric-errors"></div>
                </td>
                <td v-if="loginStatus['prodInst'] === '1'">
                  <input class="w-100 text-end" type="text" name="sdpRate" :id="'sdpRate' + index" v-model="item['sdpRate']">
                  <div class="numeric-errors"></div>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1'">
                  <span :class="loginStatus['prodInst'] !== '1' ? 'btn p-1' : 'btn p-1 text-black-50'" @click="duplicateEstimate(item['id'], 'メインオプション・ゲストオプション')">
                    <i class="bi bi-clipboard-plus"></i>
                  </span>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1'">
                  <input name="deleteCheckbox" type="checkbox" :value="JSON.stringify({'tableId': item['id'], 'itemCode': item['itemCode'], 'category': 'メインゲストオプション別種', 'mainGuestType': item['sectionM']})" :disabled="loginStatus['prodInst'] === '1'">
                </td>
                <td>
                  <div class="form-check form-switch" style="padding: 0;">
                    <input type="checkbox" class="form-check-input" :id="'toggle-display-image-' + item['id']" :v-model="displayImage[item['id']]" :checked="item['displayImage']" :disabled="loginStatus['prodInst'] === '1'" style="font-size: medium; margin-left: 0.7rem;">
                    <label class="form-check-label toggle-display-image" :for="'toggle-display-image-' + item['id']"></label>
                    <input name="displayImageCheckbox" type="hidden" :value="JSON.stringify({'id': 'toggle-display-image-' + item['id'], 'itemCode': item['itemCode'], 'category': 'メインゲストオプション別種', 'serialNo': item['serialNo']})">
                  </div>
                </td>
                <td v-if="loginStatus['prodInst'] === '1'">
                  <div class="form-check form-switch" style="padding: 0;">
                    <input type="checkbox" class="form-check-input" :id="'toggle-display-image-prodInst-' + item['id']" :v-model="displayImage[item['id']]" :checked="item['prodInstDisplayImage']" style="font-size: medium; margin-left: 0.7rem;">
                    <label class="form-check-label toggle-display-image" :for="'toggle-display-image-prodInst-' + item['id']"></label>
                    <input name="prodInstDisplayImageCheckbox" type="hidden" :value="JSON.stringify({'id': 'toggle-display-image-prodInst-' + item['id'], 'itemCode': item['itemCode'], 'category': 'メインゲストオプション別種', 'serialNo': item['serialNo']})">
                  </div>
                </td>
                <td class="align-middle" v-if="loginStatus['prodInst'] === '1'">
                  <span
                    class="border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn"
                    style="width: 30px;height: 30px;"
                    @click="goToProductionInstruction(item['itemCode'], 'メインテーブル・ゲストテーブル', item['id'], item['sectionM'] === 'メインオプション' ? 'mainopt' : 'guestopt')"
                    v-if="'itemCode' in item">
                    <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                  </span>
                </td>
              </tr>
            </tbody>

            <!-- メイン提案 -->
            <tbody v-if="Object.keys(mainOtherEstimateData).length">
              <input type="hidden" name="category" value="メインテーブル・ゲストテーブル">
              <template v-for="(mainRecord, key) in mainOtherEstimateData">
                <tr :id="item['id']" v-for="(item, index) in mainRecord['items']" :key="key + index">
                  <input type="hidden" name="tableId" :value="item['id']">
                  <td class="align-middle" :rowspan="mainRecord['items'].length" v-if="index === 0 && loginStatus['prodInst'] !== '1'">
                    <span :class="loginStatus['prodInst'] !== '1' ? 'border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn' : 'border border-dark rounded-circle d-inline-flex align-items-center justify-content-center text-black-50 btn'" @click="goToProductSelection(item['mainOtherRecordNo'], 'メインテーブル・ゲストテーブル', item['id'], 'main')" style="width: 30px;height: 30px;">
                      <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                    </span>
                  </td>
                  <td
                    class="align-middle"
                    :rowspan="mainOtherRowCount"
                    v-if="mainRecord['mainIndex'] === 0 && index === 0"
                  >{{item['sectionL']}}</td>
                  <td>{{item['sectionM']}}</td>
                  <td @click="sectionSClick('mainOtherSectionS' + index, item['sectionL'], item['sectionM'], $event)">
                    <u style="color: blue;">{{item['sectionS']}}</u>
                    <input type="text" name="setSectionS" v-model="item['sectionS']" hidden>
                    <div class="sectionS-menu-close" :id="'mainOtherSectionSClose' + index">
                      <li class="sectionS-menu">
                      ×
                      </li>
                    </div>
                    <div class="sectionS-menu-board" :id="'mainOtherSectionS' + index">
                      <ul style= "padding: 0px 0px 0px 0px; margin: 0;" v-for="(ssdata, index2) in EstimateSectionSData" v-bind:key="ssdata + index2">
                        <li :style= "item['sectionS'] === ssdata ? 'background-color:#DDEEFF;' : ''" class="sectionS-menu" @click="sectionSMenuClick('mainOther', key, index, ssdata)">{{ssdata}}</li>
                      </ul>
                    </div>
                  </td>
                  <td v-if="loginStatus['prodInst'] !== '1'">
                    <input name="compileCheckbox" :id="'checkbox-compile-' + item['id']" type="checkbox" :checked="item['compileEstimate']" :value="JSON.stringify({'id': 'checkbox-compile-' + item['id'], 'itemCode': item['itemCode'], 'category': 'メインゲストオプション別種', 'serialNo': item['serialNo'], 'mainOtherRecordNo': item['mainOtherRecordNo']})" :disabled="loginStatus['prodInst'] === '1'">
                  </td>
                  <td>
                    <textarea
                      class="form-control w-100 item-note"
                      name="itemName"
                      rows="1"
                      maxlength="50"
                      v-model="item['itemName']"
                      :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'"
                      style="overflow:hidden"
                    ></textarea>
                    <div class="numeric-errors"></div>
                  </td>
                  <!--<td class="text-end" v-if="hasPack">{{toCommaSeparated(item['packPrice'])}}</td>-->
                  <td>
                    <input class="w-100 text-end" type="text" name="packPrice" v-model="item['packPrice']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <div class="numeric-errors"></div>
                  </td>
                  <td class="text-end">
                    <input class="w-100 text-end" type="text" name="packQuantity" v-model="item['packQuantity']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <div class="numeric-errors"></div>
                  </td>
                  <td class="text-end">
                    <input class="w-70 text-end" type="text" name="packDiscount" v-model="item['packDiscount']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <span v-if="item['packDiscount']">%</span>
                    <div class="numeric-errors"></div>
                  </td>
                  <td>
                    <input class="w-100 text-end" type="text" name="itemPrice" v-model="item['itemPrice']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <div class="numeric-errors"></div>
                  </td>
                  <td class="text-end">{{toCommaSeparated(item['margin'])}}</td>
                  <td>
                    <input class="w-100 text-end" type="text" name="discount" v-model="item['discount']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <div class="numeric-errors"></div>
                  </td>
                  <td>
                    <input class="w-100 text-end" type="text" name="quantity" v-model="item['quantity']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <div class="numeric-errors"></div>
                  </td>
                  <td class="text-end">{{toCommaSeparated(item['itemEstimatePriceTotal'])}}</td>
                  <td>
                    <textarea
                      class="form-control w-100 item-note"
                      name="note"
                      rows="2"
                      maxlength="50"
                      v-model="item['note']"
                      :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'"
                      style="overflow:hidden"
                    ></textarea>
                  </td>
                  <td>
                    <input type="checkbox" value="1" name="change" :id="'mainOtherChange' + index" :checked="item['change']" @change="changeRowDisabled" v-if="loginStatus['afterMTG'] === '1'">
                    <div v-if="loginStatus['afterMTG'] !== '1' && item['change'] === '1'">★</div>
                  </td>
                  <td v-if="loginStatus['prodInst'] !== '1' && loginStatus['afterMTG'] === '1'">
                    <input class="w-100 text-end" type="text" name="commission" :id="'commission' + index" v-model="item['commission']">
                    <div class="numeric-errors"></div>
                  </td>
                  <td v-if="loginStatus['prodInst'] === '1'">
                    <input class="w-100 text-end" type="text" name="sdpRate" :id="'sdpRate' + index" v-model="item['sdpRate']">
                    <div class="numeric-errors"></div>
                  </td>
                  <td v-if="loginStatus['prodInst'] !== '1'">
                    <span :class="loginStatus['prodInst'] !== '1' ? 'btn p-1' : 'btn p-1 text-black-50'" @click="duplicateEstimate(item['id'], 'メインテーブル・ゲストテーブル')">
                      <i class="bi bi-clipboard-plus"></i>
                    </span>
                  </td>
                  <td v-if="loginStatus['prodInst'] !== '1'">
                    <input name="deleteCheckbox" type="checkbox" :value="JSON.stringify({'tableId': item['id'], 'itemCode': item['itemCode'], 'category': 'メイン提案', 'mainGuestType': 'メイン提案', 'mainOtherRecordNo': item['mainOtherRecordNo']})" :disabled="loginStatus['prodInst'] === '1'">
                  </td>
                  <td :rowspan="mainRecord['items'].length" v-if="index === 0">
                    <div class="form-check form-switch" style="padding: 0;" v-if="item['sectionM'] !== '持ち帰り'">
                      <input type="checkbox" class="form-check-input" :id="'toggle-display-image-' + item['id']" :v-model="displayImage[item['id']]" :checked="item['displayImage']" :disabled="loginStatus['prodInst'] === '1'" style="font-size: medium; margin-left: 0.7rem;">
                      <label class="form-check-label toggle-display-image" :for="'toggle-display-image-' + item['id']"></label>
                      <input name="displayImageCheckbox" type="hidden" :value="JSON.stringify({'id': 'toggle-display-image-' + item['id'], 'itemCode': null, 'category': 'メインゲストオプション別種', 'serialNo': item['serialNo'], 'mainOtherRecordNo': item['mainOtherRecordNo']})">
                    </div>
                  </td>
                  <td :rowspan="mainRecord['items'].length" v-if="index === 0 && loginStatus['prodInst'] === '1'">
                    <div class="form-check form-switch" style="padding: 0;" v-if="item['sectionM'] !== '持ち帰り'">
                      <input type="checkbox" class="form-check-input" :id="'toggle-display-image-prodInst-' + item['id']" :v-model="displayImage[item['id']]" :checked="item['prodInstDisplayImage']" style="font-size: medium; margin-left: 0.7rem;">
                      <label class="form-check-label toggle-display-image" :for="'toggle-display-image-prodInst-' + item['id']"></label>
                      <input name="prodInstDisplayImageCheckbox" type="hidden" :value="JSON.stringify({'id': 'toggle-display-image-prodInst-' + item['id'], 'itemCode': null, 'category': 'メインゲストオプション別種', 'serialNo': item['serialNo'], 'mainOtherRecordNo': item['mainOtherRecordNo']})">
                    </div>
                  </td>
                  <td class="align-middle" :rowspan="mainRecord['items'].length" v-if="index === 0 && loginStatus['prodInst'] === '1'">
                    <span class="border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn" @click="goToProductionInstruction(item['mainOtherRecordNo'], 'メインテーブル・ゲストテーブル', item['id'], 'main')" style="width: 30px;height: 30px;">
                      <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                    </span>
                  </td>
                </tr>
              </template>
            </tbody>

            <!-- ゲスト別種 -->
            <tbody v-if="Object.keys(guestOtherEstimateData).length">
              <input type="hidden" name="category" value="メインテーブル・ゲストテーブル">
              <template v-for="(guestRecord, key) in guestOtherEstimateData">
                <tr :id="item['id']" v-for="(item, index) in guestRecord['items']" :key="key + index">
                  <input type="hidden" name="tableId" :value="item['id']">
                  <td class="align-middle" :rowspan="guestRecord['items'].length" v-if="index === 0 && loginStatus['prodInst'] !== '1'">
                    <span :class="loginStatus['prodInst'] !== '1' ? 'border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn' : 'border border-dark rounded-circle d-inline-flex align-items-center justify-content-center text-black-50 btn'" @click="goToProductSelection(item['guestOtherRecordNo'], 'メインテーブル・ゲストテーブル', item['id'], 'guest')" style="width: 30px;height: 30px;">
                      <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                    </span>
                  </td>
                  <td
                    class="align-middle"
                    :rowspan="guestOtherRowCount"
                    v-if="guestRecord['guestIndex'] === 0 && index === 0"
                  >{{item['sectionL']}}</td>
                  <td>{{item['sectionM']}}</td>
                  <td @click="sectionSClick('guestOtherSectionS' + index, item['sectionL'], item['sectionM'], $event)">
                    <u style="color: blue;">{{item['sectionS']}}</u>
                    <input type="text" name="setSectionS" v-model="item['sectionS']" hidden>
                    <div class="sectionS-menu-close" :id="'guestOtherSectionSClose' + index">
                      <li class="sectionS-menu">
                      ×
                      </li>
                    </div>
                    <div class="sectionS-menu-board" :id="'guestOtherSectionS' + index">
                      <ul style= "padding: 0px 0px 0px 0px; margin: 0;" v-for="(ssdata, index2) in EstimateSectionSData" v-bind:key="ssdata + index2">
                        <li :style= "item['sectionS'] === ssdata ? 'background-color:#DDEEFF;' : ''" class="sectionS-menu" @click="sectionSMenuClick('guestOther', key, index, ssdata)">{{ssdata}}</li>
                      </ul>
                    </div>
                  </td>
                  <td v-if="loginStatus['prodInst'] !== '1'">
                    <input name="compileCheckbox" :id="'checkbox-compile-' + item['id']" type="checkbox" :checked="item['compileEstimate']" :value="JSON.stringify({'id': 'checkbox-compile-' + item['id'], 'itemCode': item['itemCode'], 'category': 'メインゲストオプション別種', 'serialNo': item['serialNo'], 'guestOtherRecordNo': item['guestOtherRecordNo']})" :disabled="loginStatus['prodInst'] === '1'">
                  </td>
                  <td>
                    <textarea
                      class="form-control w-100 item-note"
                      name="itemName"
                      rows="1"
                      max-rows="50"
                      maxlength="50"
                      v-model="item['itemName']"
                      :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'"
                      style="overflow:hidden"
                    ></textarea>
                    <div class="numeric-errors"></div>
                  </td>
                  <!--<td class="text-end" v-if="hasPack">{{toCommaSeparated(item['packPrice'])}}</td>-->
                  <td>
                    <input class="w-100 text-end" type="text" name="packPrice" v-model="item['packPrice']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <div class="numeric-errors"></div>
                  </td>
                  <td class="text-end">
                    <input class="w-100 text-end" type="text" name="packQuantity" v-model="item['packQuantity']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <div class="numeric-errors"></div>
                  </td>
                  <td class="text-end">
                    <input class="w-70 text-end" type="text" name="packDiscount" v-model="item['packDiscount']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <span v-if="item['packDiscount']">%</span>
                    <div class="numeric-errors"></div>
                  </td>
                  <td>
                    <input class="w-100 text-end" type="text" name="itemPrice" v-model="item['itemPrice']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <div class="numeric-errors"></div>
                  </td>
                  <td class="text-end">{{toCommaSeparated(item['margin'])}}</td>
                  <td>
                    <input class="w-100 text-end" type="text" name="discount" v-model="item['discount']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <div class="numeric-errors"></div>
                  </td>
                  <td>
                    <input class="w-100 text-end" type="text" name="quantity" v-model="item['quantity']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                    <div class="numeric-errors"></div>
                  </td>
                  <td class="text-end">{{toCommaSeparated(item['itemEstimatePriceTotal'])}}</td>
                  <td>
                    <textarea
                      class="form-control w-100 item-note"
                      name="note"
                      rows="2"
                      maxlength="50"
                      v-model="item['note']"
                      :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'"
                      style="overflow:hidden"
                    ></textarea>
                  </td>
                  <td>
                    <input type="checkbox" value="1" name="change" :id="'guestOtherChange' + index" :checked="item['change']" @change="changeRowDisabled" v-if="loginStatus['afterMTG'] === '1'">
                    <div v-if="loginStatus['afterMTG'] !== '1' && item['change'] === '1'">★</div>
                  </td>
                  <td v-if="loginStatus['prodInst'] !== '1' && loginStatus['afterMTG'] === '1'">
                    <input class="w-100 text-end" type="text" name="commission" :id="'commission' + index" v-model="item['commission']">
                    <div class="numeric-errors"></div>
                  </td>
                  <td v-if="loginStatus['prodInst'] === '1'">
                    <input class="w-100 text-end" type="text" name="sdpRate" :id="'sdpRate' + index" v-model="item['sdpRate']">
                    <div class="numeric-errors"></div>
                  </td>
                  <td v-if="loginStatus['prodInst'] !== '1'">
                    <span :class="loginStatus['prodInst'] !== '1' ? 'btn p-1' : 'btn p-1 text-black-50'" @click="duplicateEstimate(item['id'], 'メインテーブル・ゲストテーブル')">
                      <i class="bi bi-clipboard-plus"></i>
                    </span>
                  </td>
                  <td v-if="loginStatus['prodInst'] !== '1'">
                    <input name="deleteCheckbox" type="checkbox" :value="JSON.stringify({'tableId': item['id'], 'itemCode': item['itemCode'], 'category': 'ゲスト別種', 'mainGuestType': 'ゲスト別種', 'guestOtherRecordNo': item['guestOtherRecordNo']})" :disabled="loginStatus['prodInst'] === '1'">
                  </td>
                  <td :rowspan="guestRecord['items'].length" v-if="index === 0">
                    <div class="form-check form-switch" style="padding: 0;" v-if="item['sectionM'] !== '持ち帰り'">
                      <input type="checkbox" class="form-check-input" :id="'toggle-display-image-' + item['id']" :v-model="displayImage[item['id']]" :checked="item['displayImage']" :disabled="loginStatus['prodInst'] === '1'" style="font-size: medium; margin-left: 0.7rem;">
                      <label class="form-check-label toggle-display-image" :for="'toggle-display-image-' + item['id']"></label>
                      <input name="displayImageCheckbox" type="hidden" :value="JSON.stringify({'id': 'toggle-display-image-' + item['id'], 'itemCode': null, 'category': 'メインゲストオプション別種', 'serialNo': item['serialNo'], 'guestOtherRecordNo': item['guestOtherRecordNo']})">
                    </div>
                  </td>
                  <td :rowspan="guestRecord['items'].length" v-if="index === 0 && loginStatus['prodInst'] === '1'">
                    <div class="form-check form-switch" style="padding: 0;" v-if="item['sectionM'] !== '持ち帰り'">
                      <input type="checkbox" class="form-check-input" :id="'toggle-display-image-prodInst-' + item['id']" :v-model="displayImage[item['id']]" :checked="item['prodInstDisplayImage']" style="font-size: medium; margin-left: 0.7rem;">
                      <label class="form-check-label toggle-display-image" :for="'toggle-display-image-prodInst-' + item['id']"></label>
                      <input name="prodInstDisplayImageCheckbox" type="hidden" :value="JSON.stringify({'id': 'toggle-display-image-prodInst-' + item['id'], 'itemCode': null, 'category': 'メインゲストオプション別種', 'serialNo': item['serialNo'], 'guestOtherRecordNo': item['guestOtherRecordNo']})">
                    </div>
                  </td>
                  <td class="align-middle" :rowspan="guestRecord['items'].length" v-if="index === 0 && loginStatus['prodInst'] === '1'">
                    <span class="border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn" @click="goToProductionInstruction(item['guestOtherRecordNo'], 'メインテーブル・ゲストテーブル', item['id'], 'guest')" style="width: 30px;height: 30px;">
                      <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                    </span>
                  </td>
                </tr>
              </template>
            </tbody>
            <!-- メイン・ゲスト以外の商品 -->
            <tbody v-for="(estimate, category) in itemEstimateData" :key="category">
              <input type="hidden" name="category" :value="category">
              <tr :id="item['id']" v-for="(item, index) in estimate" :key="index" >
                <input type="hidden" name="itemCode" :value="item['itemCode']">
                <input type="hidden" name="tableId" :value="item['id']">
                <td class="align-middle" v-if="loginStatus['prodInst'] !== '1'">
                  <span
                    :class="loginStatus['prodInst'] !== '1' ? 'border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn' : 'border border-dark rounded-circle d-inline-flex align-items-center justify-content-center text-black-50 btn'"
                    style="width: 30px;height: 30px;"
                    @click="goToProductSelection(item['itemCode'], category, item['id'])"
                    v-if="'itemCode' in item && category !== '持ち帰り'">
                    <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                  </span>
                </td>
                <td class="align-middle" :rowspan="Object.keys(estimate).length" v-if="index === 0">{{item['sectionL']}}</td>
                <td>{{item['sectionM']}}</td>
                <td @click="sectionSClick('itemSectionS' + item['sectionL'] + index, item['sectionL'], item['sectionM'], $event)">
                  <u style="color: blue;">{{item['sectionS']}}</u>
                  <input type="text" name="setSectionS" v-model="item['sectionS']" hidden>
                  <div class="sectionS-menu-close" :id="'itemSectionSClose' + item['sectionL'] + index">
                    <li class="sectionS-menu">
                    ×
                    </li>
                  </div>
                  <div class="sectionS-menu-board" :id="'itemSectionS' + item['sectionL'] + index">
                    <ul style= "padding: 0px 0px 0px 0px; margin: 0;" v-for="(ssdata, index2) in EstimateSectionSData" v-bind:key="ssdata + index2">
                      <li :style= "item['sectionS'] === ssdata ? 'background-color:#DDEEFF;' : ''" class="sectionS-menu" @click="sectionSMenuClick('itemEstimate', category, index, ssdata)">{{ssdata}}</li>
                    </ul>
                  </div>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1'">
                  <input name="compileCheckbox" :id="'checkbox-compile-' + item['id']" type="checkbox" :checked="item['compileEstimate']" :value="JSON.stringify({'id': 'checkbox-compile-' + item['id'], 'itemCode': item['itemCode'], 'category': category, 'serialNo': item['serialNo']})" :disabled="loginStatus['prodInst'] === '1'">
                </td>
                <td>
                  <textarea
                    class="form-control w-100 item-note"
                    name="itemName"
                    rows="1"
                    maxlength="50"
                    v-model="item['itemName']"
                    :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'"
                  ></textarea>
                  <div class="numeric-errors"></div>
                </td>
                <!--<td class="text-end" v-if="hasPack">{{toCommaSeparated(item['packPrice'])}}</td>-->
                <td>
                  <input class="w-100 text-end" type="text" name="packPrice" v-model="item['packPrice']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td class="text-end">
                  <input class="w-100 text-end" type="text" name="packQuantity" v-model="item['packQuantity']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td class="text-end">
                  <input class="w-70 text-end" type="text" name="packDiscount" v-model="item['packDiscount']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <span v-if="item['packDiscount']">%</span>
                  <div class="numeric-errors"></div>
                </td>
                <td>
                  <input class="w-100 text-end" type="text" name="itemPrice" v-model="item['itemPrice']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td class="text-end">{{toCommaSeparated(item['margin'])}}</td>
                <!--<td class="text-end">{{item['discount'] ? item['discount'] + '%' : ''}}</td>-->
                <td>
                  <input class="w-100 text-end" type="text" name="discount" v-model="item['discount']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>
                <td>
                  <input class="w-100 text-end" type="text" name="quantity" v-model="item['quantity']" :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'">
                  <div class="numeric-errors"></div>
                </td>

                <td class="text-end">{{toCommaSeparated(item['itemEstimatePriceTotal'])}}</td>
                <td>
                  <textarea
                    class="form-control w-100 item-note"
                    name="note"
                    rows="2"
                    maxlength="50"
                    v-model="item['note']"
                    :disabled="(!item['change'] && loginStatus['afterMTG'] === '1') || loginStatus['prodInst'] === '1'"
                  ></textarea>
                </td>
                <td>
                  <input type="checkbox" value="1" name="change" :id="'itemChange' + item['sectionL'] + index" :checked="item['change'] === '1' ? true : false" @change="changeRowDisabled" v-if="loginStatus['afterMTG'] === '1'">
                  <div v-if="loginStatus['afterMTG'] !== '1' && item['change'] === '1'">★</div>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1' && loginStatus['afterMTG'] === '1'">
                  <input class="w-100 text-end" type="text" name="commission" :id="'commission' + index" v-model="item['commission']">
                  <div class="numeric-errors"></div>
                </td>
                <td v-if="loginStatus['prodInst'] === '1'">
                  <input class="w-100 text-end" type="text" name="sdpRate" :id="'sdpRate' + index" v-model="item['sdpRate']">
                  <div class="numeric-errors"></div>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1'">
                  <span :class="loginStatus['prodInst'] !== '1' ? 'btn p-1' : 'btn p-1 text-black-50'" @click="duplicateEstimate(item['id'], category)">
                    <i class="bi bi-clipboard-plus"></i>
                  </span>
                </td>
                <td v-if="loginStatus['prodInst'] !== '1'">
                  <input name="deleteCheckbox" type="checkbox" :value="JSON.stringify({'tableId': item['id'], 'itemCode': item['itemCode'], 'category': category})" :disabled="loginStatus['prodInst'] === '1'">
                </td>
                <td>
                  <div v-if="category !== '持ち帰り'" class="form-check form-switch" style="padding: 0;">
                    <input type="checkbox" class="form-check-input" :id="'toggle-display-image-' + item['id']" :v-model="displayImage[item['id']]" :checked="item['displayImage']" :disabled="loginStatus['prodInst'] === '1'" style="font-size: medium; margin-left: 0.7rem;">
                    <label class="form-check-label toggle-display-image" :for="'toggle-display-image-' + item['id']"></label>
                    <input name="displayImageCheckbox" type="hidden" :value="JSON.stringify({'id': 'toggle-display-image-' + item['id'], 'itemCode': item['itemCode'], 'category': category, 'serialNo': item['serialNo']})">
                  </div>
                </td>
                <td v-if="loginStatus['prodInst'] === '1'">
                  <div v-if="category !== '持ち帰り'" class="form-check form-switch" style="padding: 0;">
                    <input type="checkbox" class="form-check-input" :id="'toggle-display-image-prodInst-' + item['id']" :v-model="displayImage[item['id']]" :checked="item['prodInstDisplayImage']" style="font-size: medium; margin-left: 0.7rem;">
                    <label class="form-check-label toggle-display-image" :for="'toggle-display-image-prodInst-' + item['id']"></label>
                    <input name="prodInstDisplayImageCheckbox" type="hidden" :value="JSON.stringify({'id': 'toggle-display-image-prodInst-' + item['id'], 'itemCode': item['itemCode'], 'category': category, 'serialNo': item['serialNo']})">
                  </div>
                </td>
                <td v-if="loginStatus['prodInst'] === '1'" class="align-middle">
                  <span
                    class="border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn"
                    style="width: 30px;height: 30px;"
                    @click="goToProductionInstruction(item['itemCode'], category, item['id'])"
                    v-if="'itemCode' in item && category !== '持ち帰り'">
                    <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                  </span>
                </td>
              </tr>
            </tbody>

          </table>
          <table class="table mb-1 col-8 col-sm-8" style="width: 66.66666667%" v-if="estimateData('form', 'totalPriceDisplay') && estimateData('form', 'totalPriceDisplay').includes('お客様見積に表示する')">
            <tbody class="border-top">
              <tr class="mt-3">
                <td class="p-2 small" style="border-bottom: none;">{{estimateData('form', 'pack')}}合計</td>
                <td class="p-2 text-end small" style="border-bottom: none;">{{toCommaSeparated(estimateData('form', 'totalPlanPrice'))}}</td>
              </tr>
              <tr>
                <td class="pe-2 ps-2 pt-0 pb-0 small" style="border-top: none;"></td>
                <td class="pe-2 ps-2 pt-0 pb-0 text-end small" style="border-top: none;">{{estimateData('form', 'planRemarks')}}</td>
              </tr>
            </tbody>
          </table>
          <table class="table mb-0 col-8 col-sm-8" style="width: 66.66666667%">
            <tbody>
              <!-- #66 2022/09/27 start 合計金額表示制御対応 -->
              <!-- <tr class="mt-3"> -->
              <tr class="mt-3" v-if="estimateData('form', 'totalPriceExcTaxFlag') == '1'">
              <!-- #66 2022/09/27 end -->
                <td class="p-2">合計(税抜)</td>
                <td class="p-2 text-end">{{toCommaSeparated(estimateData('form', 'taxExcludeTotal'))}}</td>
              </tr>
              <!-- #66 2022/09/05 start 税込金額表示制御対応 -->
              <!--  <tr>-->
              <!-- #66 2022/09/27 start 合計金額表示制御対応 -->
              <!-- <tr v-if="estimateData('form', 'hiddenTotalPriceIncTaxFlag') != '表示しない'"> -->
              <tr v-if="estimateData('form', 'totalPriceIncTaxFlag') == '1'">
              <!-- #66 2022/09/27 end -->
              <!-- #66 2022/09/05 end -->
                <td class="p-2">合計(税込)</td>
                <td class="p-2 text-end">{{toCommaSeparated(estimateData('form', 'taxIncludeTotal'))}}</td>
              </tr>
              <tr v-if="estimateData('form', 'pack') && estimateData('form', 'totalPriceText') && (estimateData('form', 'totalPriceExcTaxFlag') == '1' || estimateData('form', 'totalPriceIncTaxFlag') == '1')">
                <td class="p-2"></td>
                <td class="p-2 text-end" style="font-size: 65%; color: #adadff;">{{estimateData('form', 'totalPriceText')}}</td>
              </tr>
            </tbody>
          </table>

          <div class="text-center my-5">
            <BButton variant="primary" @click="updateEstimate" :disabled="loginStatus['referenceFlag'] === '1'" v-if="loginStatus['prodInst'] !== '1'">見積を保存</BButton>
            <BButton variant="primary" @click="updateProductionInstruction" :disabled="loginStatus['referenceFlag'] === '1'" v-else>制作指示を保存</BButton>
          </div>
        </BOverlay>
      </BOffcanvas>
      <BOffcanvas v-model="showSidebar3" class="sidebar p-4 test-1" id="sidebar-3" no-backdrop placement="end" style="--bs-offcanvas-width:1250px; z-index:100;" no-header>
        <BOverlay :show="memoOverlayShow" rounded="sm">
          <div id="general-memo">
            <BFormGroup class="fw-bold" style="margin-bottom: 1rem;">
              <label for="customer-message">お客様伝達事項<span class="ms-2 note-small">※最大1000文字まで入力できます。</span></label>
              <BFormTextarea
                id="customer-message"
                name="customerMessage"
                rows="3"
                max-rows="21"
                maxlength="1021"
                v-model="generalMemo.customerMessage"
                :disabled="loginStatus['prodInst'] === '1'"
                style="overflow-y: scroll;"
             ></BFormTextarea>
            </BFormGroup>
            <BFormGroup style="margin-bottom: 1rem;">
              <label for="planner-message">プランナー伝達事項<span class="ms-2 note-small">※最大1000文字まで入力できます。</span></label>
              <BFormTextarea
                id="planner-message"
                name="plannerMessage"
                rows="3"
                max-rows="21"
                maxlength="1021"
                v-model="generalMemo.plannerMessage"
                :disabled="loginStatus['prodInst'] === '1'"
                style="overflow-y: scroll;"
              ></BFormTextarea>
            </BFormGroup>
            <BFormGroup style="margin-bottom: 1rem;">
              <label for="sdp-message">制作伝達事項<span class="ms-2 note-small">※最大1000文字まで入力できます。</span></label>
              <BFormTextarea
                id="sdp-message"
                name="sdpMessage"
                rows="3"
                max-rows="21"
                maxlength="1021"
                v-model="generalMemo.sdpMessage"
                style="overflow-y: scroll;"
              ></BFormTextarea>
            </BFormGroup>
            <BFormGroup class="mt-3" style="margin-bottom: 1rem;">
              <label for="employee-memo">社内メモ欄<span class="ms-2 note-small">※最大1000文字まで入力できます。</span></label>
              <BFormTextarea
                id="employee-memo"
                name="employeeMemo"
                rows="3"
                max-rows="21"
                maxlength="1021"
                v-model="generalMemo.employeeMemo"
                style="overflow-y: scroll;"
              ></BFormTextarea>
            </BFormGroup>
            <div class="text-center my-5">
              <BButton variant="primary" @click="saveGeneralMemo" :disabled="loginStatus['referenceFlag'] === '1'">メモを保存</BButton>
            </div>
          </div>
        </BOverlay>
      </BOffcanvas>
      <BOffcanvas v-model="showSidebar4"  class="sidebar p-4 test-1" id="sidebar-4" placement="end" no-backdrop style="--bs-offcanvas-width:1250px; z-index:100;" no-header>
        <BOverlay :show="memoOverlayShow" rounded="sm">
          <div id="wrapper-meeting-memo">
            <label class="mt-3" for="meeting-memo">打合せメモ欄<span class="ms-2 note-small">※最大1000文字まで入力できます。</span></label>
            <span
              class="border border-dark rounded-circle d-inline-flex align-items-center justify-content-center m-2"
              role="button"
              @click="toggleMeetingMemo"
              :aria-expanded="isMeetingMemoOpen"
              aria-controls="collapse-meeting-memo-canvas"
              style="width: 30px;height: 30px;"
            >
              <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
            </span>
            <BFormTextarea
              id="meeting-memo"
              name="meetingMemo"
              rows="3"
              max-rows="21"
              maxlength="1021"
              v-model="meetingMemo.text"
              :disabled="loginStatus['prodInst'] === '1'"
              style="overflow-y: scroll;"
            ></BFormTextarea>
            <BCollapse id="collapse-meeting-memo-canvas" v-model="isMeetingMemoOpen" class="mt-3">
              <img v-if="loginStatus['prodInst'] === '1'" :src="meetingMemo['image']" />
              <div v-if="loginStatus['prodInst'] !== '1'">
              <DrawCanvas
                :memoBackGroundImage="meetingMemo['image']"
                :drawMode="drawMode"
                :penColor="penColor"
                :lineWidth="lineWidth"
                :allClearFlag="allClearFlag"
                @saveMeetingMemo="saveMeetingMemo"
                ref="drawCanvas"/>
              </div>
              <div class="row col-sm-12 mt-3">
                <div v-if="loginStatus['prodInst'] !== '1'" class="col-lg-2 col-sm-3 me-2">
                  <label class="mb-0 small" for="penColor">ペンカラー</label>
                  <input class="w-100 mt-1" type="color" list @change="changePenColor" v-model="penColor" name="penColor" id="penColor">
                </div>
                <div v-if="loginStatus['prodInst'] !== '1'" class="col-lg-2 col-sm-3 ms-2">
                  <label class="mb-0 small" for="drawMode">モード</label>
                  <select class="w-100 mt-1" v-model="drawMode" name="drawMode" id="drawMode">
                    <option value="source-over" selected>ペン</option>
                    <option value="destination-out">消しゴム</option>
                  </select>
                </div>
                <div v-if="loginStatus['prodInst'] !== '1'" class="col-lg-2 col-sm-3 ms-2">
                  <label class="mb-0 small" for="lineWidth">太さ</label>
                  <select class="w-100 mt-1" v-model="lineWidth" name="lineWidth" id="lineWidth">
                    <option value="2" selected>2px</option>
                    <option value="6">6px</option>
                    <option value="10">10px</option>
                    <option value="30">30px</option>
                    <option value="50">50px</option>
                    <option value="100">100px</option>
                    <option value="200">200px</option>
                    <option value="300">300px</option>
                  </select>
                </div>
                <div v-if="loginStatus['prodInst'] !== '1'" class="text-end col-lg-2 col-sm-3 me-2">
                  <BButton variant="outline-secondary" class="mt-4" style="font-size:80%" @click="clearCanvas">クリア</BButton>
                </div>
                <div v-if="loginStatus['prodInst'] !== '1'" class="col-lg-2 col-sm-3">
                  <BButton variant="outline-secondary" class="mt-4" style="font-size:80%" @click="allClearCanvas">オールクリア</BButton>
                </div>
              </div>
            </BCollapse>
            <div class="text-center my-5">
              <BButton v-if="loginStatus['prodInst'] !== '1'" variant="primary" @click="exportDrawnImage" :disabled="loginStatus['referenceFlag'] === '1'">メモを保存</BButton>
            </div>
          </div>
        </BOverlay>
      </BOffcanvas>
      <CommonModal ref="commonModal" @confirmOk="execFunction(true)" />
      <CommonModal ref="commonModalMeetingIdCheck" @confirmOk="restartMeeting" />
      <AddEstimateItemModal ref="addEstimateItemModal" @reloadEstimate="reloadEstimate" />
    </div>
  </header>
</template>
<script>
import CommonModal from '@/components/CommonModal'
import ImageUploadModal from '@/components/ImageUploadModal'
import UploadImageShowModal from '@/components/UploadImageShowModal'
import ProductionInstructionUploadImageShowModal from '@/components/ProductionInstructionUploadImageShowModal'
import MainGuestImageDisplayModal from '@/components/MainGuestImageDisplayModal'
import MainGuestProdInstImageDisplayModal from '@/components/MainGuestProdInstImageDisplayModal'
import AddEstimateItemModal from '@/components/AddEstimateItemModal'
import BookmarkModal from '@/components/BookmarkModal'
import ProductionInstructionBookmarkModal from '@/components/ProductionInstructionBookmarkModal'
import DrawCanvas from '@/components/DrawCanvas'
import SearchConditionsModel from '@/models/SearchConditionsModel'
import HeaderEstimateModel from '@/models/HeaderEstimateModel'
import EstimateUpdateModel from '@/models/EstimateUpdateModel'
import EstimateImageUpdateModel from '@/models/EstimateImageUpdateModel'
import ProductionInstructionImageUpdateModel from '@/models/ProductionInstructionImageUpdateModel'
import EstimateDeleteModel from '@/models/EstimateDeleteModel'
import MeetingInfoUpdateModel from '@/models/MeetingInfoUpdateModel'
import MeetingInfoGetModel from '@/models/MeetingInfoGetModel'
import MemoModel from '@/models/MemoModel'
import MemoRegistModel from '@/models/MemoRegistModel'
import SignalingModel from '@/models/SignalingModel'
import MainGuestImageDisplayModel from '@/models/MainGuestImageDisplayModel'
import PlanModel from '@/models/PlanModel'
import PackModel from '@/models/PackModel'
import CategoryListModel from '@/models/CategoryListModel'
import MeetingStartModel from '@/models/MeetingStartModel'
import CookieInfoModel from '@/models/CookieInfoModel'
import fstore from '@/store/florist-store'
import mstore from '@/store/meeting-store'
import logoff from '@/mixins/logoff'
import CommonLogModel from '@/models/CommonLogModel'
import vSelect from 'vue-select'
import { ref, nextTick, createApp } from 'vue'
import 'vue-select/dist/vue-select.css'
const app = createApp({})
const commonModal = ref(null)
app.component('v-select', vSelect)

export default {
  name: 'FloristHeader',
  components: { CommonModal, ImageUploadModal, UploadImageShowModal, ProductionInstructionUploadImageShowModal, MainGuestImageDisplayModal, MainGuestProdInstImageDisplayModal, DrawCanvas, AddEstimateItemModal, BookmarkModal, ProductionInstructionBookmarkModal, vSelect },
  data () {
    return {
      searchOverlayShow: false,
      estimateOverlayShow: false,
      memoOverlayShow: false,
      isProjectTypeMain: false,
      isProjectTypeEstimate: false,
      isShowItemCode: false,
      projectTypes: [],
      projectType: '',
      searchTypes: [],
      conditions: {'sectionS': {}, 'styles': {}, 'seasons': {}, 'colors': {}, 'shapes': {}, 'figures': {}, 'mainoptSectionS': {}, 'guestoptSectionS': {}, 'mainShapes': [], 'guestShapes': []},
      viewStyles: {},
      viewStylesCountMax: 0,
      EstimateSectionSData: [],
      mainGuestEstimateData: {},
      itemEstimateData: {},
      mainGuestOptionData: {},
      mainOtherEstimateData: {},
      guestOtherEstimateData: {},
      mainOtherRowCount: 0,
      guestOtherRowCount: 0,
      mainRowCount: 0,
      guestRowCount: 0,
      mainGuestProjectNumber: '',
      generalMemo: {'employeeMemo': '', 'customerMessage': '', 'plannerMessage': '', 'sdpMessage': ''},
      meetingMemo: {'text': '', 'image': ''},
      suggestionType: 'style',
      sectionS: [],
      mainSectionS: '',
      guestSectionS: '',
      mainoptSectionS: '',
      guestoptSectionS: '',
      style: [],
      season: '',
      color: [],
      mainShape: [],
      guestShape: [],
      shape: '',
      figure: '',
      shisetsu: '施設特有以外',
      mainPriceFrom: '',
      mainPriceTo: '',
      guestPriceFrom: '',
      guestPriceTo: '',
      priceFrom: '',
      priceTo: '',
      cordinateMaker: '',
      afterBouquetMaker: '',
      facilityType: '',
      facilityCode: '',
      coreProduct: false,
      normalCoreProduct: false,
      facilitySpecific: false,
      estimateDeleteTarget: {},
      penColor: '#000000',
      app_env: process.env.APP_ENV,
      drawMode: 'source-over',
      lineWidth: '2',
      hasPack: false,
      showSidebar1: false,
      showSidebar2: false,
      showSidebar3: false,
      showSidebar4: false,
      isMeetingMemoOpen: false,
      maxSideberZIndex1: 1100,
      maxSideberZIndex2: 1100,
      maxSideberZIndex3: 1100,
      maxSideberZIndex4: 1100,
      loginStatus: '',
      displayImage: {},
      isOpenCanvas: false,
      attendanceUpdateData: 0,
      planOptions: [''],
      planEstimateData: '',
      packOptions: [''],
      packEstimateData: '',
      prodBaseOptions: [],
      prodBaseName: '',
      beforeChangeProdBaseName: '',
      operationPtnOptions: ['1型：完全内製', '2型：拠点制作', '3型：葬儀', '4型：制作・納品外注', '制作外注', '5型：完全外注'],
      operationPtnName: '',
      prodBaseList: [],
      estimateUpdateRegistData: {},
      displayImageParams: {},
      allClearFlag: false,
      attendeeTypeMapping: {'01': 'florist', '02': 'customer'},
      mainGuestImageDisplayData: {
        'image1': {
          'display': false,
          'hasImage': false
        },
        'image2': {
          'display': false,
          'hasImage': false
        },
        'image3': {
          'display': false,
          'hasImage': false
        },
        'image4': {
          'display': false,
          'hasImage': false
        },
        'image5': {
          'display': false,
          'hasImage': false
        }
      },
      mainGuestProdInstImageDisplayData: {
        'image1': {
          'display': false,
          'hasImage': false
        },
        'image2': {
          'display': false,
          'hasImage': false
        },
        'image3': {
          'display': false,
          'hasImage': false
        },
        'image4': {
          'display': false,
          'hasImage': false
        },
        'image5': {
          'display': false,
          'hasImage': false
        }
      },
      customerDisplayFlag: fstore.getters.customerDisplayFlag === null ? false : fstore.getters.customerDisplayFlag,
      cookieProjectNumber: '',
      isAllSelected: false,
      notAllSelectList: ['Disney', 'Simple', 'BEST BRIDAL', 'Prefix Wedding'],
      allSelectList: [],
      prodBaseAndOpPtnDisabledFlag: false,
      memoTypeElementIdList: ['customer-message', 'employee-memo', 'planner-message', 'sdp-message', 'meeting-memo']
    }
  },
  async mounted () {
    fstore.commit('setIsFirstGetHeaderEstimate', true)
    if (localStorage.getItem('projectTypes') !== null) {
      this.projectTypes = JSON.parse(localStorage.getItem('projectTypes'))
    }
    await nextTick()
    if (localStorage.getItem('suggestionData') !== null) {
      this.restoreSearchConditions()
    }
    // GETパラメータにprojectNumberとpasswordがあるとき、ログイン前として処理する
    if ('projectNumber' in this.$route.query && 'password' in this.$route.query) {
      this.loginStatus = {
        'beforeLogin': '1',
        'afterMTG': 'afterMTG' in this.$route.query ? this.$route.query.afterMTG : '0',
        'prodInst': 'prodInst' in this.$route.query ? this.$route.query.prodInst : '0',
        'referenceFlag': 'referenceFlag' in this.$route.query ? this.$route.query.referenceFlag : '0'
      }
    } else {
      this.loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
      if (!this.loginStatus) {
        this.loginStatus = {
          'beforeLogin': '0',
          'afterMTG': 'afterMTG' in this.$route.query ? this.$route.query.afterMTG : '0',
          'prodInst': 'prodInst' in this.$route.query ? this.$route.query.prodInst : '0',
          'referenceFlag': 'referenceFlag' in this.$route.query ? this.$route.query.referenceFlag : '0'
        }
      }
    }
    console.log(this.loginStatus)

    // Cookieの打合せIDを取得し変数に格納
    if (this.$route.path !== '/florist/meeting') {
      let params = ['projectNumber']
      let currentCookieProjectNumber = await CookieInfoModel.apiSetStore(this.$bvModal, params, () => {})
      this.cookieProjectNumber = currentCookieProjectNumber['cookieInfo']
    }

    // リロード時はrouter.beforeEach()が動作しないのでbeforeunloadで最終ページを設定
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('lastRoutePath', this.$route.path)
    })
  },
  computed: {
    getIsOperationPossible () {
      return fstore.getters.isOperationPossible
    },
    isJumpPage () {
      return this.consts.floristHamburgerMenuEnableJumpPages.includes(this.$parent.$parent.$options.name)
    },
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    },
    suggestionTypeStyle () {
      return '0'
    },
    suggestionTypeCoordinate () {
      return '1'
    }
  },
  watch: {
    getSignalingData (newData, oldData) {
      if (newData['event'] === 'click') {
        if (newData['id'] === 'modalUploadImage') {
          this.$refs.imageUploadModal.floristUploadFile()
        } else if (newData['id'] === 'modalUploadImageComplete') {
          this.$refs.imageUploadModal.changeBody('uploadImageComplete')
        }
      }
      console.log(newData['event'])
      if (newData['event'] === 'text') {
        if (newData['id'] === 'customerAttendeeId') {
          mstore.commit('setCustomerAttendeeId', newData['data'])
        }
      }
    }
  },
  methods: {
    estimateData (datatype, key = null) {
      const store = HeaderEstimateModel.getStore()
      if (!store) {
        return null
      }
      return key ? store.headerEstimate[datatype][key] : store.headerEstimate[datatype]
    },
    handleIconClick () {
      this.openMainGuestImageDisplayModal()
    },
    handleProdInstIconClick () {
      this.openMainGuestProdInstImageDisplayModal()
    },
    onClickMenuButton () {
      this.toggleSearchMenu()
      this.ownShowAndOtherbSidebarHide('sidebar-1')
      this.$nextTick(() => {
        const sidebar = document.querySelector('.sidebar')
      })
    },
    toggleSearchMenu () {
      if (localStorage.getItem('projectTypes') === null || localStorage.getItem('suggestionData') === null) {
        this.reloadProjectTypes()
      }
    },
    toggleSearchMenuAndOpen () {
      this.toggleSearchMenu()
      this.ownShowAndOtherbSidebarHide('sidebar-1')
    },
    restoreSearchConditions: async function () {
      const suggestionData = JSON.parse(localStorage.getItem('suggestionData'))
      this.projectType = Object.keys(suggestionData).length && suggestionData.projectType ? suggestionData.projectType[0] : ''
      if (suggestionData.suggestionType) this.suggestionType = suggestionData.suggestionType[0]
      await this.reloadProjectTypes()
      for (const [key, value] of Object.entries(suggestionData)) {
        if (key === 'style') {
          // this.style.splice(0, this.style.length)
          for (const v of Object.values(value)) {
            // スタイル提案の場合はスタイル番号がセットされた配列形式になっているので、スタイル番号(=id)をキーにelementを取得する
            if (typeof v === 'object') {
              // const styleValue = Object.values(v)[0]
              this.style.push(Object.values(v)[0])
            } else {
              if (document.getElementById('style' + v)) {
                // const styleValue = document.getElementById('style' + v).value
                this.style.push(document.getElementById('style' + v).value)
              }
            }
          }
        } else {
          this[key] = Array.isArray(this[key]) ? value : value[0]
        }
      }
      if (this.allSelectList.every((num) => this.style.includes(num))) {
        this.isAllSelected = true
      } else {
        this.isAllSelected = false
      }
    },
    changeProjectType (e) {
      this.isShowItemCode = false
      this.projectType = e.target.value
      this.setSearchTypes(e.target.value)
      // 検索条件をリセット
      this.sectionS = []
      this.mainSectionS = ''
      this.guestSectionS = ''
      this.style = []
      this.season = ''
      this.color = []
      this.mainShape = []
      this.guestShape = []
      this.shape = []
      this.figure = ''
      this.shisetsu = JSON.parse(localStorage.getItem('productFirstDisplay')) === true ? '施設特有のみ' : '施設特有以外'
      this.mainPriceFrom = ''
      this.mainPriceTo = ''
      this.guestPriceFrom = ''
      this.guestPriceTo = ''
      this.priceFrom = ''
      this.priceTo = ''
      this.cordinateMaker = ''
      this.afterBouquetMaker = ''
      this.facilityType = ''
      this.facilityCode = ''
      this.coreProduct = false
      this.normalCoreProduct = JSON.parse(localStorage.getItem('focusProductFirstDisplay')) === true
      this.facilitySpecific = JSON.parse(localStorage.getItem('specFirstDisplay')) === true
      this.isAllSelected = false
    },
    changeSuggestionType () {
      this.setSearchTypes('メインテーブル・ゲストテーブル')
      // 検索条件をリセット
      this.sectionS = []
      this.mainSectionS = ''
      this.guestSectionS = ''
      this.style = []
      this.season = ''
      this.color = []
      this.mainShape = []
      this.guestShape = []
      this.shape = []
      this.figure = ''
      this.shisetsu = JSON.parse(localStorage.getItem('productFirstDisplay')) === true ? '施設特有のみ' : '施設特有以外'
      this.mainPriceFrom = ''
      this.mainPriceTo = ''
      this.guestPriceFrom = ''
      this.guestPriceTo = ''
      this.priceFrom = ''
      this.priceTo = ''
      this.cordinateMaker = ''
      this.afterBouquetMaker = ''
      this.facilityType = ''
      this.facilityCode = ''
      this.coreProduct = false
      this.normalCoreProduct = JSON.parse(localStorage.getItem('focusProductFirstDisplay')) === true
      this.facilitySpecific = JSON.parse(localStorage.getItem('specFirstDisplay')) === true
      this.isAllSelected = false
    },
    reloadProjectTypes: async function () {
      this.searchOverlayShow = true
      const params = {'conditionType': 'suggestion'}
      const resData = await SearchConditionsModel.apiSetStore(this.$bvModal, params, () => {
        this.searchOverlayShow = false
      })
      const sectionL = Object.values(resData.sectionL)
      localStorage.setItem('projectTypes', JSON.stringify(sectionL))
      if (!this.projectType.length) {
        this.projectType = sectionL[0]
      }
      this.projectTypes = sectionL
      this.setSearchTypes(this.projectType)
    },
    setSearchTypes (projectType) {
      this.projectType = projectType
      const store = SearchConditionsModel.getStore()
      if (!store) {
        return false
      }
      const searchTypes = ['styles', 'seasons', 'colors', 'shapes', 'figures', 'cordinateMakers', 'afterBouquetMakers', 'facilityTypes', 'mainoptSectionS', 'guestoptSectionS', 'mainShapes', 'guestShapes']
      for (let i = 0; i < searchTypes.length; i++) {
        this.conditions[searchTypes[i]] = store[searchTypes[i]]
      }
      this.conditions['sectionS'] = store['sectionS'][projectType]

      if (projectType === 'メインテーブル・ゲストテーブル') {
        this.isProjectTypeMain = true
        this.isProjectTypeEstimate = false

        // 画面に表示するスタイル
        this.viewStyles = {}
        this.allSelectList = []
        this.viewStylesCountMax = 0
        for (let styleDataKey in this.conditions['styles']) {
          let styleData = this.conditions['styles'][styleDataKey]
          // スペック提案とメイン提案とゲスト種別のとき、「スペック提案時に表示」するスタイルを表示する
          if (styleData.onlySpec === 0 || (styleData.onlySpec === 1 && (this.suggestionType === 'cordinate' || this.suggestionType === 'main' || this.suggestionType === 'guest'))) {
            this.viewStyles[styleDataKey] = styleData
            this.viewStylesCountMax++
            if (!this.notAllSelectList.includes(styleData.styleName)) {
              this.allSelectList.push(styleData.styleName)
            }
          }
        }

        switch (this.suggestionType) {
          case 'style':
            this.searchTypes = ['style']
            break
          case 'cordinate':
            this.searchTypes = ['style', 'main-table-types', 'guest-table-types', 'mainShape', 'guestShape', 'mainPrice', 'guestPrice', 'mainGuestSeason', 'color', 'facilityType', 'facilityCode', 'coreProduct', 'facilitySpecific']
            break
          case 'mainopt':
            this.searchTypes = ['style', 'price', 'season', 'color', 'normalCoreProduct']
            break
          case 'guestopt':
            this.searchTypes = ['style', 'price', 'season', 'color', 'normalCoreProduct']
            break
          case 'main':
            this.searchTypes = ['style', 'main-table-types', 'mainShape', 'mainPrice', 'mainGuestSeason', 'color', 'facilityType', 'facilityCode', 'coreProduct', 'facilitySpecific']
            break
          case 'guest':
            this.searchTypes = ['style', 'guest-table-types', 'guestShape', 'guestPrice', 'mainGuestSeason', 'color', 'facilityType', 'facilityCode', 'coreProduct', 'facilitySpecific']
            break
          default:
            break
        }
      } else {
        this.isProjectTypeMain = false
        this.isProjectTypeEstimate = false
        switch (projectType) {
          case 'コーディネート':
            this.searchTypes = ['color', 'cordinateMaker', 'shisetsu', 'normalCoreProduct']
            break
          case '演出':
            this.searchTypes = ['price', 'shisetsu', 'normalCoreProduct']
            break
          case 'その他装飾':
            this.searchTypes = ['shisetsu', 'normalCoreProduct']
            break
          case '贈呈':
            this.searchTypes = ['price', 'shisetsu', 'normalCoreProduct']
            break
          case '挙式関係':
            this.searchTypes = ['shisetsu', 'normalCoreProduct']
            break
          case 'ブーケ':
            this.searchTypes = ['season', 'color', 'price', 'shisetsu', 'normalCoreProduct']
            break
          case 'エターナルブーケ':
            this.searchTypes = ['figure', 'afterBouquetMaker', 'shisetsu', 'normalCoreProduct']
            break
          case '持ち帰り':
          case '指名料':
          case '花材指定料':
            this.searchTypes = ['shisetsu', 'normalCoreProduct']
            break
        }
      }
    },
    changeSectionS (section) {
      this.isShowItemCode = (section.target.value === 'プチギフト' || section.target.value === '贈呈用ギフト')
    },
    itemSuggestion () {
      // 操作をフローリストにする
      this.changeIsOperationPossible(true)
      // ブーケの場合、小区分がチェックボックスとなるため、そのための処理
      if (this.projectType === 'ブーケ') {
        const checkedCount = this.sectionSCheckedCounter()
        if (checkedCount === 0) {
          this.$refs.commonModal.msgBoxOk('小区分を選択してください')
        } else if (checkedCount > 5) {
          this.$refs.commonModal.msgBoxOk('選択可能な小区分は５つまでです')
        } else {
          this.execSuggestion('itemSuggestion')
        }
      } else {
        // ブーケ以外の場合の商品提案処理
        const sectionSRadio = document.getElementById('section-s').querySelectorAll('input[name="sectionS"]')
        let isChecked = false
        for (let i = 0; i < sectionSRadio.length; i++) {
          if (sectionSRadio[i].checked) {
            isChecked = true
          }
        }

        if (isChecked) {
          this.execSuggestion('itemSuggestion')
        } else {
          this.$refs.commonModal.msgBoxOk('小区分を選択してください')
        }
      }
    },
    mainGuestSuggestion () {
      // 操作をフローリストにする
      this.changeIsOperationPossible(true)
      if (this.suggestionType === 'style') {
        this.styleSuggestion()
      } else if (this.suggestionType === 'cordinate') {
        this.cordinateSuggestion()
      } else if (this.suggestionType === 'mainopt') {
        this.mainoptSuggestion()
      } else if (this.suggestionType === 'guestopt') {
        this.guestoptSuggestion()
      } else if (this.suggestionType === 'main') {
        this.mainSuggestion()
      } else if (this.suggestionType === 'guest') {
        this.guestSuggestion()
      }
    },
    styleSuggestion () {
      const checkedCount = this.styleCheckedCounter()
      if (checkedCount === 0) {
        this.$refs.commonModal.msgBoxOk('スタイルを選択してください')
      } else if (checkedCount > 3) {
        this.$refs.commonModal.msgBoxOk('選択可能なスタイルは３つまでです')
      } else {
        this.execSuggestion('styleSuggestion')
      }
    },
    cordinateSuggestion () {
      const checkedCount = this.styleCheckedCounter()
      if (checkedCount === 0) {
        this.$refs.commonModal.msgBoxOk('スタイルを選択してください')
      } else {
        this.execSuggestion('cordinateSuggestion')
      }
    },
    mainoptSuggestion () {
      const checkedCount = this.mainoptCheckedCounter()
      if (checkedCount === 0) {
        this.$refs.commonModal.msgBoxOk('小区分を選択してください')
      } else if (checkedCount !== 1) {
        this.$refs.commonModal.msgBoxOk('選択可能な小区分は１つまでです')
      } else {
        this.execSuggestion('mainoptSuggestion')
      }
    },
    guestoptSuggestion () {
      const checkedCount = this.guestoptCheckedCounter()
      if (checkedCount === 0) {
        this.$refs.commonModal.msgBoxOk('小区分を選択してください')
      } else if (checkedCount !== 1) {
        this.$refs.commonModal.msgBoxOk('選択可能な小区分は１つまでです')
      } else {
        this.execSuggestion('guestoptSuggestion')
      }
    },
    mainSuggestion () {
      const checkedCount = this.styleCheckedCounter()
      if (checkedCount === 0) {
        this.$refs.commonModal.msgBoxOk('スタイルを選択してください')
      } else {
        this.execSuggestion('mainSuggestion')
      }
    },
    guestSuggestion () {
      const checkedCount = this.styleCheckedCounter()
      if (checkedCount === 0) {
        this.$refs.commonModal.msgBoxOk('スタイルを選択してください')
      } else {
        this.execSuggestion('guestSuggestion')
      }
    },
    styleCheckedCounter () {
      return document.querySelectorAll('input[name="style"]:checked').length
    },
    sectionSCheckedCounter () {
      return document.querySelectorAll('input[name="sectionS"]:checked').length
    },
    mainoptCheckedCounter () {
      return document.querySelectorAll('input[name="mainoptSectionS"]:checked').length
    },
    guestoptCheckedCounter () {
      return document.querySelectorAll('input[name="guestoptSectionS"]:checked').length
    },
    estimate: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      if (this.$route.path !== '/florist/meeting/estimate') {
        // 操作をフローリストにする
        this.changeIsOperationPossible(true)
        this.execSuggestion('estimate')
      } else {
        this.toggleEstimate(false)
        this.$emit('emitReload')
      }
    },
    execSuggestion: async function (buttonType) {
      const suggestionData = this.createSuggestionData([
        document.getElementById('project-types'),
        document.getElementById('suggestion-types'),
        document.getElementById('section-s'),
        document.getElementById('search-conditions')
      ])
      localStorage.setItem('suggestionData', JSON.stringify(suggestionData))

      // suggestionDataの情報をdynamoDBに登録
      const updateData = {
        'suggestionData': JSON.stringify(suggestionData),
        'attendeeType': this.consts.attendeeType.florist
      }
      await MeetingInfoUpdateModel.apiSetStore(this.$bvModal, updateData, () => {})

      await this.movePage(buttonType)
      this.$emit('suggestion')
      this.closeMenu()
    },
    createSuggestionData (targetElements) {
      let suggestionData = {}
      for (let elem of targetElements) {
        if (elem === null) {
          continue
        }
        const inputs = elem.querySelectorAll('input')
        for (let i = 0; i < inputs.length; i++) {
          if ((inputs[i].type === 'checkbox' || inputs[i].type === 'radio') && inputs[i].checked === false) {
            continue
          }
          if ((inputs[i].type === 'text' || inputs[i].type === 'number') && !inputs[i].value) {
            continue
          }
          if (inputs[i].dataset.paramName in suggestionData) {
            if (inputs[i].dataset.paramName === 'style') {
              suggestionData[inputs[i].dataset.paramName].push(this.suggestionType === 'style' ? inputs[i].dataset.styleNumber : {[inputs[i].dataset.styleCode]: inputs[i].value})
            } else {
              // suggestionData[inputs[i].dataset.paramName].push(inputs[i].value)
              if (!suggestionData[inputs[i].dataset.paramName].includes(inputs[i].value)) { // 重複チェック
                suggestionData[inputs[i].dataset.paramName].push(inputs[i].value)
              }
            }
          } else {
            if (inputs[i].dataset.paramName === 'style') {
              suggestionData[inputs[i].dataset.paramName] = this.suggestionType === 'style' ? [inputs[i].dataset.styleNumber] : [{[inputs[i].dataset.styleCode]: inputs[i].value}]
            } else {
              suggestionData[inputs[i].dataset.paramName] = [inputs[i].value]
            }
          }
        }

        // メイン形状、ゲスト形状はinputではないため、個別に設定
        suggestionData['mainShape'] = this.mainShape
        suggestionData['guestShape'] = this.guestShape
      }
      return suggestionData
    },
    movePage (buttonType) {
      if (localStorage.getItem('suggestionData') === null) {
        return this.$refs.commonModal.msgBoxOk('提案条件を設定してください')
      }
      const suggestionData = JSON.parse(localStorage.getItem('suggestionData'))
      const projectType = Object.keys(suggestionData).length && suggestionData.projectType ? suggestionData.projectType[0] : ''
      let targetPath = null
      if (buttonType === 'cordinateSuggestion' || buttonType === 'mainoptSuggestion' || buttonType === 'guestoptSuggestion' || buttonType === 'mainSuggestion' || buttonType === 'guestSuggestion') {
        targetPath = '/florist/meeting/product_proposal'
        // 商品一覧を表示した履歴が残っている場合、保存したスクロール位置含めて削除
        if (sessionStorage.getItem('proposalScrollHistoryFlag') !== null) {
          sessionStorage.removeItem('proposalScrollHistoryFlag')
          sessionStorage.removeItem('scrollY')
        }
      } else if (buttonType === 'estimate') {
        targetPath = '/florist/meeting/estimate'
      } else if (this.consts.projectType.main.indexOf(projectType) !== -1) {
        targetPath = '/florist/meeting/style_image_proposal'
      } else {
        targetPath = '/florist/meeting/product_proposal'
        // 商品一覧を表示した履歴が残っている場合、保存したスクロール位置含めて削除
        if (sessionStorage.getItem('proposalScrollHistoryFlag') !== null) {
          sessionStorage.removeItem('proposalScrollHistoryFlag')
          sessionStorage.removeItem('scrollY')
        }
      }
      if (targetPath !== this.$route.path) {
        SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.allSidebarHide()
        this.$router.push(targetPath)
      }
    },
    moveToAgenda () {
      const targetPath = '/florist/meeting/agenda'
      if (targetPath !== this.$route.path) {
        SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      }
    },
    moveToInput: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      const targetPath = '/florist/meeting/input'
      if (targetPath !== this.$route.path) {
        SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      }
    },
    moveToHearing () {
      const targetPath = '/florist/meeting/hearing'
      if (targetPath !== this.$route.path) {
        SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      }
    },
    closeMenu () {
      try {
        const menuElem = document.getElementById('menu-trigger')
        // null チェックを追加
        if (menuElem && menuElem.classList && menuElem.classList.contains('active')) {
          menuElem.click()
        }
      } catch (err) {
        console.error('closeMenu エラー:', err)
      }
    },
    changeIsOperationPossible (isOperationPossible = null) {
      if (isOperationPossible === null) {
        isOperationPossible = !fstore.getters.isOperationPossible
      }
      fstore.commit('setIsOperationPossible', isOperationPossible)
      const operationType = fstore.getters.isOperationPossible ? 'operationInvalid' : 'operationPossible'
      SignalingModel.sendClickEvent(operationType, this)

      // 権限の情報をdynamoDBに登録
      const updateData = {
        'operatingPrivilege': fstore.getters.isOperationPossible ? '0' : '1',
        'attendeeType': this.consts.attendeeType.florist
      }
      MeetingInfoUpdateModel.apiSetStore(this.$bvModal, updateData, () => {})
    },
    changeCustomerDisplayFlag () {
      const customerDisplayFlag = !fstore.getters.customerDisplayFlag
      fstore.commit('setCustomerDisplayFlag', customerDisplayFlag)
      const operationType = fstore.getters.customerDisplayFlag ? 'priceDisplay' : 'priceHide'
      SignalingModel.sendClickEvent(operationType, this)

      // 権限の情報をdynamoDBに登録
      const updateData = {
        'customerDisplayFlag': fstore.getters.customerDisplayFlag ? '1' : '0',
        'attendeeType': this.consts.attendeeType.florist
      }
      MeetingInfoUpdateModel.apiSetStore(this.$bvModal, updateData, () => {})
    },
    openImageUploadModal () {
      if (this.$refs.imageUploadModal) {
        // FloristHeaderの定数値を確認
        const attendeeType = this.consts?.attendeeType?.florist || '01'
        this.$refs.imageUploadModal.showModal(attendeeType)
      } else {
        console.error('ImageUploadModal reference not found')
      }
    },
    debugButtonClick () {
      this.openUploadImageShowModal()
    },
    openUploadImageShowModal () {
      // コンポーネントの状態確認
      if (this.$refs.uploadImageShowModal) {
        try {
          const attendeeType = this.consts?.attendeeType?.florist || '01'

          const result = this.$refs.uploadImageShowModal.showModal(attendeeType)
        } catch (error) {
          console.error('Error calling showModal:', error)
        }
      } else {
        console.error('uploadImageShowModal ref is null/undefined')
        // DOM内での検索
        const element = document.querySelector('[ref="uploadImageShowModal"]')
      }
    },
    openProductionInstructionUploadImageShowModal () {
      const modalRef = this.$refs.productionInstructionUploadImageShowModal
      if (modalRef && typeof modalRef.showModal === 'function') {
        modalRef.showModal(this.consts.attendeeType.florist)
      } else {
        console.error('Error: The ref "productionInstructionUploadImageShowModal" is not found or is invalid.')
      }
    },
    openBookmarkModal () {
      this.$refs.bookmarkModal.showModal(this.consts.attendeeType.florist)
    },
    openProductionInstructionBookmarkModal () {
      this.$refs.productionInstructionBookmarkModal.showModal(this.consts.attendeeType.florist)
    },
    openMainGuestImageDisplayModal () {
      if (this.loginStatus['prodInst'] !== '1') {
        this.$refs.mainGuestImageDisplayModal.showModal()
      }
    },
    openMainGuestProdInstImageDisplayModal () {
      console.log(this.$refs)
      this.$refs.mainGuestProdInstImageDisplayModal.showModal()
    },
    signalingModalChangeSend (clickName, params = null) {
      SignalingModel.sendClickEvent(clickName, this, params)
    },
    toggleEstimate (isShowEstimate) {
      document.getElementById('estimate-trigger').classList.toggle('active')
      if (document.getElementById('estimate-trigger').classList.contains('active') && fstore.getters.isFirstGetHeaderEstimate) {
        this.setEstimate()
        if (isShowEstimate) {
          fstore.commit('setIsFirstGetHeaderEstimate', false)
        }
      }
      this.ownShowAndOtherbSidebarHide('sidebar-2')
    },
    setEstimate: async function () {
      // セル結合用の変数を初期化
      this.mainRowCount = 0
      this.guestRowCount = 0
      this.estimateOverlayShow = true
      // 見積表に表示するデータを初期化
      this.attendanceUpdateData = 0
      this.planEstimateData = ''
      this.planOptions = ['']
      this.packEstimateData = ''
      this.packOptions = ['']
      this.prodBaseOptions = []
      this.prodBaseName = ''
      this.beforeChangeProdBaseName = ''
      this.operationPtnName = ''
      this.mainGuestEstimateData = {}
      this.mainGuestOptionData = {}
      this.mainOtherEstimateData = {}
      this.guestOtherEstimateData = {}
      this.itemEstimateData = {}
      this.prodBaseAndOpPtnDisabledFlag = false
      // kintoneからデータ取得
      const resData = await HeaderEstimateModel.apiSetStore(this.$bvModal)
      console.log(resData)
      if (resData.headerEstimate.pack) {
        this.hasPack = true
      }
      let mainGuestIndex = 0
      for (const [key, value] of Object.entries(resData.headerEstimate.table)) {
        if (key === 'メインテーブル') {
          // メイン提案レコード番号（メイン提案の切り替わり判定用）
          let curMainOtherRecordNoSerialNo = ''
          let mainIndex = 0
          let mainOtherList = []
          const mainOptions = []
          for (const items of Object.values(value)) {
            // パック項目使用フラグ設定
            items['packFlg'] = (items['packPrice'] || items['packQuantity'] || items['packDiscount'])
            // コミッション、SDP委託率の設定
            items['commission'] = 'commission' in items ? items['commission'] : 0
            items['sdpRate'] = 'sdpRate' in items ? items['sdpRate'] : 0

            // メイン提案の場合はメイン提案用の変数にレコードを追加
            if ('mainOtherRecordNo' in items && items['mainOtherRecordNo']) {
              this.mainOtherRowCount++
              if (curMainOtherRecordNoSerialNo !== items['mainOtherRecordNo'] + '-' + items['serialNo']) {
                // メイン提案レコード番号が切り替わった場合の処理
                if (curMainOtherRecordNoSerialNo) {
                  // メイン提案レコード番号が空(初期値)でなければ、画面表示の変数にメイン提案のリストをセット（メイン提案で2種類以上決定していた場合の処理）
                  this.mainOtherEstimateData[[key + curMainOtherRecordNoSerialNo]] = {'items': mainOtherList, 'mainIndex': mainIndex}
                  mainIndex++
                  mainOtherList = []
                }
                // 現在のメイン提案レコード番号の値を変更
                curMainOtherRecordNoSerialNo = items['mainOtherRecordNo'] + '-' + items['serialNo']
              }
              // メイン提案のリストに1行分のデータを追加
              mainOtherList.push(items)
            } else if (items['sectionM'] === 'メインオプション' && !('specOptionProduct' in items)) {
              // メインオプションの場合は商品データの方にレコードを追加
              mainOptions.push(items)
            } else {
              // メインオプション以外の場合はメインゲスト用のデータにレコードを追加
              this.mainGuestEstimateData[[key + this.mainRowCount]] = {'items': items, 'mainGuestIndex': mainGuestIndex}
              this.mainRowCount++
              mainGuestIndex++
            }
          }
          // メイン提案のデータがあれば、メイン提案の表示用変数にリストをセット
          if (mainOtherList.length) {
            this.mainOtherEstimateData[[key + curMainOtherRecordNoSerialNo]] = {'items': mainOtherList, 'mainIndex': mainIndex}
          }
          // メインオプションのデータがあれば、商品データ表示用の変数にリストをセット
          if (mainOptions.length) {
            this.mainGuestOptionData[key] = mainOptions
          } else {
            this.mainGuestOptionData[key] = []
          }
        } else if (key === 'ゲストテーブル') {
          // ゲスト別種レコード番号（ゲスト別種の切り替わり判定用）
          let curGuestOtherRecordNoSerialNo = ''
          let guestIndex = 0
          let guestOtherList = []
          const guestOptions = []
          for (const items of Object.values(value)) {
            // パック項目使用フラグ設定
            items['packFlg'] = (items['packPrice'] || items['packQuantity'] || items['packDiscount'])
            // コミッション、SDP委託率の設定
            items['commission'] = 'commission' in items ? items['commission'] : 0
            items['sdpRate'] = 'sdpRate' in items ? items['sdpRate'] : 0

            // ゲスト別種の場合はゲスト別種用の変数にレコードを追加
            if ('guestOtherRecordNo' in items && items['guestOtherRecordNo']) {
              this.guestOtherRowCount++
              if (curGuestOtherRecordNoSerialNo !== items['guestOtherRecordNo'] + '-' + items['serialNo']) {
                // ゲスト別種レコード番号が切り替わった場合の処理
                if (curGuestOtherRecordNoSerialNo) {
                  // ゲスト別種レコード番号が空(初期値)でなければ、画面表示の変数にゲスト別種のリストをセット（ゲスト別種で2種類以上決定していた場合の処理）
                  this.guestOtherEstimateData[[key + curGuestOtherRecordNoSerialNo]] = {'items': guestOtherList, 'guestIndex': guestIndex}
                  guestIndex++
                  guestOtherList = []
                }
                // 現在のゲスト別種レコード番号の値を変更
                curGuestOtherRecordNoSerialNo = items['guestOtherRecordNo'] + '-' + items['serialNo']
              }
              // ゲスト別種のリストに1行分のデータを追加
              guestOtherList.push(items)
            // ゲストオプションの場合は商品データの方にレコードを追加
            } else if (items['sectionM'] === 'ゲストオプション' && !('specOptionProduct' in items)) {
              guestOptions.push(items)
            // それ以外の場合はメインゲスト用のデータにレコードを追加
            } else {
              this.mainGuestEstimateData[[key + this.guestRowCount]] = {'items': items, 'mainGuestIndex': mainGuestIndex}
              this.guestRowCount++
              mainGuestIndex++
            }
          }
          // ゲスト別種のデータがあれば、ゲスト別種の表示用変数にリストをセット
          if (guestOtherList.length) {
            this.guestOtherEstimateData[[key + curGuestOtherRecordNoSerialNo]] = {'items': guestOtherList, 'guestIndex': guestIndex}
          }
          // ゲストオプションのデータがあれば、商品データ表示用の変数にリストをセット
          if (guestOptions.length) {
            this.mainGuestOptionData[key] = guestOptions
          }
        } else {
          const itemList = []
          for (const items of Object.values(value)) {
            // パック項目使用フラグ設定
            items['packFlg'] = (items['packPrice'] || items['packQuantity'] || items['packDiscount'])
            // コミッション、SDP委託率の設定
            items['commission'] = 'commission' in items ? items['commission'] : 0
            items['sdpRate'] = 'sdpRate' in items ? items['sdpRate'] : 0
            itemList.push(items)
          }
          this.itemEstimateData[key] = itemList
        }
        console.log(this.mainGuestEstimateData)
        console.log(this.mainGuestOptionData)
        console.log(this.mainOtherEstimateData)
        console.log(this.guestOtherEstimateData)
        console.log(this.itemEstimateData)
      }
      this.mainGuestProjectNumber = resData.headerEstimate.mainGuestProjectNumber
      let result = await MainGuestImageDisplayModel.apiSetStore(this.$bvModal, () => {
      })
      for (let i = 1; i < 6; i++) {
        this.mainGuestImageDisplayData['image' + i]['display'] = result['data']['image' + i]['display']
        this.mainGuestImageDisplayData['image' + i]['hasImage'] = result['data']['image' + i]['hasImage']
        this.mainGuestProdInstImageDisplayData['image' + i]['display'] = result['data']['prodInstImage' + i]['display']
        this.mainGuestProdInstImageDisplayData['image' + i]['hasImage'] = result['data']['prodInstImage' + i]['hasImage']
      }

      this.attendanceUpdateData = resData.headerEstimate.form.attendance
      // プラン、パックの初期値を設定
      this.planEstimateData = resData.headerEstimate.form.plan
      this.packEstimateData = resData.headerEstimate.form.pack

      // 施設に紐づくプラン、パック名をプラン、パックマスタから取得
      const facilityName = resData.headerEstimate.form.facilityName
      const planOptionsResult = await PlanModel.apiSetStore(this.$bvModal, facilityName, () => {
      })
      for (const planOptionsResults in planOptionsResult['records']) {
        this.planOptions.push(planOptionsResult['records'][planOptionsResults]['プラン名']['value'])
      }

      const packOptionsResult = await PackModel.apiSetStore(this.$bvModal, facilityName, () => {
      })
      for (const packOptionsResults in packOptionsResult['records']) {
        this.packOptions.push(packOptionsResult['records'][packOptionsResults]['パック名']['value'])
      }

      // 制作担当、委託有無の初期値を設定
      this.prodBaseList = resData.headerEstimate.form.prodBaseList
      for (const pbl in this.prodBaseList) {
        if (resData.headerEstimate.form.prodBaseCode === this.prodBaseList[pbl]['制作拠点コード']) {
          this.prodBaseName = this.prodBaseList[pbl]['制作拠点名']
          this.beforeChangeProdBaseName = this.prodBaseList[pbl]['制作拠点名']
        }
        this.prodBaseOptions.push(this.prodBaseList[pbl]['制作拠点名'])
      }
      let opPtn = resData.headerEstimate.form.operationPtn
      this.operationPtnName = this.shiftOperationPtn(true, opPtn)
      // 制作担当、委託有無は制作指示実行日時が空でなければ(制作指示実行をしていれば)非活性にする
      if (resData.headerEstimate.form.prodInsExeDate !== '') {
        this.prodBaseAndOpPtnDisabledFlag = true
      }
      this.estimateOverlayShow = false
    },
    setMemo: async function () {
      this.memoOverlayShow = true
      const params = {'memoType': ['general', 'meeting']}
      const memo = await MemoModel.apiSetStore(this.$bvModal, params, () => {
        this.memoOverlayShow = false
      })
      for (const memoType of Object.keys(memo.generalMemo)) {
        this.generalMemo[memoType] = memo.generalMemo[memoType]
      }
      for (const memoType of Object.keys(memo.meetingMemo)) {
        this.meetingMemo[memoType] = memo.meetingMemo[memoType]
      }

      // DOMの更新が完了してからテキストエリアの幅を調整する
      await nextTick()
      for (let i = 0; i < this.memoTypeElementIdList.length; i++) {
        let el = document.getElementById(this.memoTypeElementIdList[i]);
        el.style.height = 'auto'
        const maxLines = 21; // 最大行数

        // 1行あたりの高さ
        const lineHeight = 25;
        // 現在の入力内容から改行の数を数える
        const text = el.value;
        const lines = text.split('\n').length;

        // 最大行数に達したか判定
        if (lines >= maxLines) {
          // 高さを最大行数分に固定
          el.style.height = (maxLines * lineHeight) + 'px';
        } else {
          // 入力内容に合わせて高さを自動調整
          el.style.height = el.scrollHeight + 'px';
        }
      }
    },
    isNumeric (val) {
      return /^-?\d+$/.test(val)
    },
    isDecimal (val) {
      return new RegExp(/^([1-9]\d*|0)(\.\d{1,2})?$/).test(val)
    },
    updateEstimate: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      let registData = {}
      let deleteItems = {}
      let isChecked = false
      const items = document.getElementsByName('deleteCheckbox')
      // 見積削除用パラメータ
      for (let i = 0; i < items.length; i++) {
        if (items[i].checked) {
          isChecked = true
          const info = JSON.parse(items[i].value)
          if (info['tableId'] !== undefined) {
            let itemLength = 1
            let category = info['category']
            if (category in deleteItems) {
              deleteItems[category].push({'tableId': info['tableId'], 'itemCode': info['itemCode']})
              itemLength = deleteItems[category].length
            } else {
              deleteItems[category] = [{'tableId': info['tableId'], 'itemCode': info['itemCode']}]
            }
            if (info['mainGuestType']) {
              deleteItems[category][itemLength - 1]['mainGuestType'] = info['mainGuestType']
            }
            if (info['mainOtherRecordNo']) {
              deleteItems[category][itemLength - 1]['mainOtherRecordNo'] = info['mainOtherRecordNo']
            }
            if (info['guestOtherRecordNo']) {
              deleteItems[category][itemLength - 1]['guestOtherRecordNo'] = info['guestOtherRecordNo']
            }
          }
        }
      }
      // 見積表示フラグ更新用パラメータ
      const displayImageItems = document.getElementsByName('displayImageCheckbox')
      let displayImageParams = {}
      for (let i = 0; i < displayImageItems.length; i++) {
        const info = JSON.parse(displayImageItems[i].value)
        const category = info['category']
        if (category === 'アフターブーケ' || category === 'エターナルブーケ') {
          if ('エターナルブーケ' in displayImageParams === false && 'アフターブーケ' in displayImageParams === false) {
            displayImageParams[category] = {}
          }
        } else {
          if (category in displayImageParams === false) {
            displayImageParams[category] = {}
          }
        }
        if (info['itemCode'] !== null) {
          if (category === 'アフターブーケ' && 'エターナルブーケ' in displayImageParams) {
            displayImageParams['エターナルブーケ'][info['itemCode'] + '&' + info['serialNo']] = document.getElementById(info['id']).checked
          } else if (category === 'エターナルブーケ' && 'アフターブーケ' in displayImageParams) {
            displayImageParams['アフターブーケ'][info['itemCode'] + '&' + info['serialNo']] = document.getElementById(info['id']).checked
          } else {
            displayImageParams[category][info['itemCode'] + '&' + info['serialNo']] = document.getElementById(info['id']).checked
          }
        } else if (info['mainOtherRecordNo']) {
          displayImageParams[category][info['serialNo'] + 'main' + info['mainOtherRecordNo']] = document.getElementById(info['id']).checked
        } else if (info['guestOtherRecordNo']) {
          displayImageParams[category][info['serialNo'] + 'guest' + info['guestOtherRecordNo']] = document.getElementById(info['id']).checked
        }
      }
      this.displayImageParams = displayImageParams
      // 見積まとめフラグ更新用パラメータ
      const compileItems = document.getElementsByName('compileCheckbox')
      console.log(compileItems)
      let compileParams = {}
      for (let i = 0; i < compileItems.length; i++) {
        const info = JSON.parse(compileItems[i].value)
        const category = info['category']
        if (category === 'アフターブーケ' || category === 'エターナルブーケ') {
          if ('エターナルブーケ' in compileParams === false && 'アフターブーケ' in compileParams === false) {
            compileParams[category] = {}
          }
        } else {
          if (category in compileParams === false) {
            compileParams[category] = {}
          }
        }
        if (info['itemCode'] !== null && info['mainOtherRecordNo'] === undefined && info['guestOtherRecordNo'] === undefined) {
          if (category === 'アフターブーケ' && 'エターナルブーケ' in compileParams) {
            compileParams['エターナルブーケ'][info['itemCode'] + '&' + info['serialNo']] = document.getElementById(info['id']).checked
          } else if (category === 'エターナルブーケ' && 'アフターブーケ' in compileParams) {
            compileParams['アフターブーケ'][info['itemCode'] + '&' + info['serialNo']] = document.getElementById(info['id']).checked
          } else {
            compileParams[category][info['itemCode'] + '&' + info['serialNo']] = document.getElementById(info['id']).checked
          }
        } else if (info['mainOtherRecordNo']) {
          compileParams[category][info['itemCode'] + '&' + info['serialNo'] + 'main' + info['mainOtherRecordNo']] = document.getElementById(info['id']).checked
        } else if (info['guestOtherRecordNo']) {
          compileParams[category][info['itemCode'] + '&' + info['serialNo'] + 'guest' + info['guestOtherRecordNo']] = document.getElementById(info['id']).checked
        }
      }
      this.displayImageParams['compileParams'] = compileParams

      // 見積更新用パラメータ
      let estimateTbody = document.getElementById('estimate-table').getElementsByTagName('tbody')
      // 指名料や花材指定料は除外する（別の形式で更新用データを準備するため）
      const OTHER_FEES_ID = 'other-fees-tbody'
      estimateTbody = Array.prototype.filter.call(estimateTbody, e => e.id !== OTHER_FEES_ID)

      // 項目の入力チェック
      let isNumericFlg = false
      let isInputtedPackPrice = false
      for (const tbodyKey of Object.keys(estimateTbody)) {
        let tr = estimateTbody[tbodyKey].getElementsByTagName('tr')
        for (const td of Object.values(tr)) {
          let estimateInputs = td.getElementsByTagName('input')
          let estimateTextareas = td.getElementsByTagName('textarea')
          let tableId = td.getElementsByTagName('input').tableId.value

          console.log('tableId' + tableId)
          console.log(document.getElementById(tableId))

          // 商品名チェック
          const itemNameErrElem = document.getElementById(tableId).querySelectorAll('textarea[name="itemName"]+.numeric-errors')
          if (itemNameErrElem.length > 0) {
            itemNameErrElem[0].innerText = ''
          }
          if (estimateTextareas['itemName'].value === '') {
            itemNameErrElem[0].innerText = '入力してください'
            isNumericFlg = true
          }
          if (estimateTextareas['itemName'].value.includes('\n') || estimateTextareas['itemName'].value.includes('\r') || estimateTextareas['itemName'].value.includes('\r\n')) {
            itemNameErrElem[0].innerText = '改行は使用出来ません'
            isNumericFlg = true
          }
          // 商品単価チェック
          const itemPriceErrElem = document.getElementById(tableId).querySelectorAll('input[name="itemPrice"]+.numeric-errors')
          if (itemPriceErrElem.length > 0) {
            itemPriceErrElem[0].innerText = ''
          }
          if (estimateInputs['itemPrice'].value !== '') {
            if (this.isNumeric(estimateInputs['itemPrice'].value) === false) {
              console.log('itemPrice error')
              itemPriceErrElem[0].innerText = '数値で入力してください'
              isNumericFlg = true
            } else {
              /*
              if (Number(estimateInputs['itemPrice'].value) < 0) {
                console.log('itemPrice error')
                itemPriceErrElem[0].innerText = '0以上の数値で入力してください'
                isNumericFlg = true
              }
              */
            }
          } else {
            itemPriceErrElem[0].innerText = '入力してください'
            isNumericFlg = true
          }
          // 数量チェック
          const quantityErrElem = document.getElementById(tableId).querySelectorAll('input[name="quantity"]+.numeric-errors')
          if (quantityErrElem.length > 0) {
            quantityErrElem[0].innerText = ''
          }
          if (estimateInputs['quantity']) {
            if (estimateInputs['quantity'].value === '') {
              estimateInputs['quantity'].value = '0'
            }
            if (this.isDecimal(estimateInputs['quantity'].value) === false) {
              console.log('quantity error')
              quantityErrElem[0].innerText = '0.00以上の数値で入力してください'
              isNumericFlg = true
            } else if (Number(estimateInputs['quantity'].value) < 0) {
              console.log('quantity error')
              quantityErrElem[0].innerText = '0.00以上の数値で入力してください'
              isNumericFlg = true
            } else {
              if (estimateInputs['packQuantity'] && estimateInputs['packQuantity'].value !== '') {
                if (Number(estimateInputs['quantity'].value) > Number(estimateInputs['packQuantity'].value)) {
                  console.log('quantity error')
                  quantityErrElem[0].innerText = 'パック数量以下の数値で入力してください'
                  isNumericFlg = true
                }
              }
            }
          }
          // 割引率チェック
          const discountErrElem = document.getElementById(tableId).querySelectorAll('input[name="discount"]+.numeric-errors')
          if (discountErrElem.length > 0) {
            discountErrElem[0].innerText = ''
          }
          if (estimateInputs['discount'] && estimateInputs['discount'].value !== '') {
            if (this.isDecimal(estimateInputs['discount'].value) === false) {
              console.log('discount error')
              discountErrElem[0].innerText = '0.00以上の数値で入力してください'
              isNumericFlg = true
            } else {
              if (Number(estimateInputs['discount'].value) < 0) {
                console.log('discount error')
                discountErrElem[0].innerText = '0.00以上の数値で入力してください'
                isNumericFlg = true
              }
            }
          }
          // パック単価チェック
          const packPriceErrElem = document.getElementById(tableId).querySelectorAll('input[name="packPrice"]+.numeric-errors')
          if (packPriceErrElem.length > 0) {
            packPriceErrElem[0].innerText = ''
          }
          if (estimateInputs['packPrice'] && estimateInputs['packPrice'].value !== '') {
            if (this.isNumeric(estimateInputs['packPrice'].value) === false) {
              console.log('packPrice error')
              packPriceErrElem[0].innerText = '0以上の数値で入力してください'
              isNumericFlg = true
            } else {
              /*
              if (Number(estimateInputs['packPrice'].value) < 0) {
                console.log('packPrice error')
                packPriceErrElem[0].innerText = '0以上の数値で入力してください'
                isNumericFlg = true
              }
              */
            }
            isInputtedPackPrice = true
          }
          // パック数量チェック
          const packQuantityErrElem = document.getElementById(tableId).querySelectorAll('input[name="packQuantity"]+.numeric-errors')
          if (packQuantityErrElem.length > 0) {
            packQuantityErrElem[0].innerText = ''
          }
          if (estimateInputs['packQuantity'] && estimateInputs['packQuantity'].value !== '') {
            if (this.isDecimal(estimateInputs['packQuantity'].value) === false) {
              console.log('packQuantity error')
              packQuantityErrElem[0].innerText = '0.00以上の数値で入力してください'
              isNumericFlg = true
            } else {
              if (Number(estimateInputs['packQuantity'].value) < 0) {
                console.log('packQuantity error')
                packQuantityErrElem[0].innerText = '0.00以上の数値で入力してください'
                isNumericFlg = true
              }
            }
          } else {
            // パック数量に値が入っていないが、パック単価またはパック割引率に値が入っている場合メッセージを表示
            if ((estimateInputs['packDiscount'] && estimateInputs['packDiscount'].value !== '') || (estimateInputs['packPrice'] && estimateInputs['packPrice'].value !== '')) {
              console.log('packQuantity error')
              packQuantityErrElem[0].innerText = 'パック商品の場合、パック数量の入力が必須です'
              isNumericFlg = true
            }
          }
          // パック割引率チェック
          const packDiscountErrElem = document.getElementById(tableId).querySelectorAll('input[name="packDiscount"]+span+.numeric-errors')
          if (packDiscountErrElem.length > 0) {
            packDiscountErrElem[0].innerText = ''
          }
          if (estimateInputs['packDiscount'] && estimateInputs['packDiscount'].value !== '') {
            if (this.isDecimal(estimateInputs['packDiscount'].value) === false) {
              console.log('packDiscount error')
              packDiscountErrElem[0].innerText = '0.00以上の数値で入力してください'
              isNumericFlg = true
            } else {
              if (Number(estimateInputs['packDiscount'].value) < 0) {
                console.log('packDiscount error')
                packDiscountErrElem[0].innerText = '0.00以上の数値で入力してください'
                isNumericFlg = true
              }
            }
          }
          // コミッションチェック
          const commissionErrElem = document.getElementById(tableId).querySelectorAll('input[name="commission"]+.numeric-errors')
          if (commissionErrElem.length > 0) {
            commissionErrElem[0].innerText = ''
          }
          if (estimateInputs['commission']) {
            if (estimateInputs['commission'].value === '') {
              estimateInputs['commission'].value = '0'
            }
            if (this.isDecimal(estimateInputs['commission'].value) === false) {
              console.log('commission error')
              commissionErrElem[0].innerText = '0.00以上の数値で入力してください'
              isNumericFlg = true
            } else {
              if (Number(estimateInputs['commission'].value) < 0) {
                console.log('commission error')
                commissionErrElem[0].innerText = '0.00以上の数値で入力してください'
                isNumericFlg = true
              }
            }
          }
        }
      }
      // 人数チェック
      const attendanceErrElem = document.getElementById('attendanceErrElem')
      if (attendanceErrElem) {
        attendanceErrElem.innerText = ''
      }
      if (this.attendanceUpdateData !== '') {
        if (this.isNumeric(this.attendanceUpdateData) === false) {
          console.log('attendance error')
          attendanceErrElem.innerText = '0以上の数値で入力してください'
          isNumericFlg = true
        } else {
          if (Number(this.attendanceUpdateData) < 0) {
            console.log('attendance error')
            attendanceErrElem.innerText = '0以上の数値で入力してください'
            isNumericFlg = true
          }
        }
      }
        // パックチェック
      const packErrElem = document.getElementById('packErrElem')
      if (packErrElem) {
        packErrElem.innerText = ''
      }
      // 1つ以上パック単価が入力されているが、パックが設定されていない場合、エラーを出す
      if (isInputtedPackPrice && this.packEstimateData == '') {
        console.log('pack error')
        packErrElem.innerText = 'パックを選択してください'
        isNumericFlg = true
      }
      console.log('エラー確認')
      // 数値エラーの場合は処理終了
      if (isNumericFlg === true) {
        console.log('数値エラー')
        return
      }

      // 見積更新用パラメータ
      for (const tbodyKey of Object.keys(estimateTbody)) {
        let tr = estimateTbody[tbodyKey].getElementsByTagName('tr')
        let category = estimateTbody[tbodyKey].getElementsByTagName('input').category.value
        if (category in registData === false) {
          registData[category] = {}
        }
        for (const td of Object.values(tr)) {
          let estimateInputs = td.getElementsByTagName('input')
          let estimateTextareas = td.getElementsByTagName('textarea')
          console.log(estimateInputs)
          let tableId = td.getElementsByTagName('input').tableId.value
          registData[category][tableId] = {}
          registData[category][tableId]['sectionS'] = estimateInputs['setSectionS'].value
          registData[category][tableId]['itemName'] = estimateTextareas['itemName'].value
          registData[category][tableId]['itemPrice'] = estimateInputs['itemPrice'].value
          registData[category][tableId]['quantity'] = estimateInputs['quantity'].value
          registData[category][tableId]['discount'] = estimateInputs['discount'].value
          registData[category][tableId]['note'] = estimateTextareas['note'].value
          registData[category][tableId]['change'] = ''
          registData[category][tableId]['packPrice'] = ''
          registData[category][tableId]['packQuantity'] = ''
          registData[category][tableId]['packDiscount'] = ''
          if (estimateInputs['change']) {
            if (estimateInputs['change'].checked === true) {
              registData[category][tableId]['change'] = estimateInputs['change'].value
            }
          }
          if (estimateInputs['packPrice']) {
            registData[category][tableId]['packPrice'] = estimateInputs['packPrice'].value
          }
          if (estimateInputs['packQuantity']) {
            registData[category][tableId]['packQuantity'] = estimateInputs['packQuantity'].value
          }
          if (estimateInputs['packDiscount']) {
            registData[category][tableId]['packDiscount'] = estimateInputs['packDiscount'].value
          }
          if (estimateInputs['commission']) {
            registData[category][tableId]['commission'] = estimateInputs['commission'].value
          }
          if (estimateInputs['sdpRate']) {
            registData[category][tableId]['sdpRate'] = estimateInputs['sdpRate'].value
          }
        }
      }

      // 見積更新用パラメータ(商品以外)
      registData['form'] = {}
      registData['form']['attendance'] = this.attendanceUpdateData
      registData['form']['plan'] = this.planEstimateData
      registData['form']['pack'] = this.packEstimateData

      this.estimateUpdateRegistData = registData
      if (isChecked) {
        this.estimateDeleteTarget = deleteItems
        this.$refs.commonModal.msgBoxConfirm('チェックボックスで選択した商品を削除します。よろしいですか？')
      } else {
        this.execFunction(false)
      }
    },
    execFunction: async function (isDelete) {
      this.estimateOverlayShow = true
      this.displayImageParams['メインテーブル・ゲストテーブル'] = this.mainGuestImageDisplayData
      await EstimateImageUpdateModel.apiSetStore(this.$bvModal, this.displayImageParams, () => {
      })
      this.displayImageParams = {}
      if (isDelete) {
        await this.execDeleteEstimate()
      }
      this.saveEstimate(this.estimateUpdateRegistData)
      this.estimateUpdateRegistData = {}
    },
    execDeleteEstimate: async function () {
      this.estimateOverlayShow = true
      SignalingModel.sendClickEvent('deleteEstimate', this)
      await EstimateDeleteModel.apiSetStore(this.$bvModal, this.estimateDeleteTarget, () => {
      })
      this.reloadEstimate()
    },
    duplicateEstimate: async function (tableId, category) {
      if (this.loginStatus['prodInst'] !== '1') {
        let registData = {[category]: {[tableId]: {}}}
        const inputs = document.getElementById(tableId).getElementsByTagName('input')
        let textareas = document.getElementById(tableId).getElementsByTagName('textarea')
        for (const input of Object.values(inputs)) {
          registData[category][tableId][input.name] = input.value
        }
        registData[category][tableId]['note'] = textareas['note'].value
        // 非表示でinputが存在しない項目について、連想配列に空文字を格納する
        if (!('packPrice' in registData[category][tableId])) {
          registData[category][tableId]['packPrice'] = ''
        }
        if (!('packQuantity' in registData[category][tableId])) {
          registData[category][tableId]['packQuantity'] = ''
        }
        if (!('packDiscount' in registData[category][tableId])) {
          registData[category][tableId]['packDiscount'] = ''
        }
        registData[category][tableId]['change'] = ''
        if (inputs['change']) {
          if (inputs['change'].checked === true) {
            registData[category][tableId]['change'] = inputs['change'].value
          }
        }
        registData[category][tableId]['isDuplicate'] = 'True'
        this.saveEstimate(registData)
      }
    },
    saveEstimate: async function (registData) {
      this.estimateOverlayShow = true
      await EstimateUpdateModel.apiSetStore(this.$bvModal, registData, () => {})
      this.mainGuestEstimateData = {}
      this.mainGuestOptionData = {}
      this.mainOtherEstimateData = {}
      this.guestOtherEstimateData = {}
      this.itemEstimateData = {}
      this.setEstimate()
    },
    saveGeneralMemo: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      let registData = {'generalMemo': {}}
      const generalMemo = document.getElementById('general-memo').getElementsByTagName('textarea')
      for (const key of Object.keys(generalMemo)) {
        registData['generalMemo'][generalMemo[key].name] = generalMemo[key].value
      }
      if (this.loginStatus['prodInst'] === '1') {
        registData['prodInst'] = '1'
      }
      this.memoOverlayShow = true
      await MemoRegistModel.apiSetStore(this.$bvModal, registData, () => {
        this.memoOverlayShow = false
      })
    },
    saveMeetingMemo: async function (dataURL) {
      let registData = {}
      const meetingMemo = document.getElementById('meeting-memo').value
      registData['meetingMemo'] = meetingMemo

      registData['meetingMemoImage'] = dataURL.replace(/^.*,/, '')
      this.memoOverlayShow = true
      await MemoRegistModel.apiSetStore(this.$bvModal, registData, () => {
        this.memoOverlayShow = false
      })
    },
    goToProductSelection: async function (projectNumber, projectType, tableRowId, suggestionType = '') {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      if (this.loginStatus['prodInst'] !== '1') {
        let suggestionData = localStorage.getItem('suggestionData') ? JSON.parse(localStorage.getItem('suggestionData')) : ''
        // suggestionTypeをセット
        if (suggestionData) {
          if (projectType === 'お客様画像' || projectType === 'ブックマーク') {
            suggestionData['suggestionType'] = [projectType]
            localStorage.setItem('suggestionData', JSON.stringify(suggestionData))
          } else {
            suggestionData['suggestionType'] = [suggestionType]
            localStorage.setItem('suggestionData', JSON.stringify(suggestionData))
          }

          // suggestionDataの情報をdynamoDBに登録
          const updateData = {
            'suggestionData': JSON.stringify(suggestionData),
            'attendeeType': this.consts.attendeeType.florist
          }
          MeetingInfoUpdateModel.apiSetStore(this.$bvModal, updateData, () => {})
        } else {
          if (projectType === 'お客様画像' || projectType === 'ブックマーク') {
            localStorage.setItem('suggestionData', JSON.stringify({'suggestionType': [projectType]}))
          } else {
            localStorage.setItem('suggestionData', JSON.stringify({'suggestionType': [suggestionType]}))
          }

          // suggestionDataの情報をdynamoDBに登録
          const updateData = {
            'suggestionData': localStorage.getItem('suggestionData'),
            'attendeeType': this.consts.attendeeType.florist
          }
          MeetingInfoUpdateModel.apiSetStore(this.$bvModal, updateData, () => {})

          suggestionData = JSON.parse(localStorage.getItem('suggestionData'))
        }
        console.log('suggestionData ↓')
        console.log(suggestionData)
        const targetPath = '/florist/meeting/product_selection/' + projectNumber
        console.log('targetPath → ' + targetPath)
        console.log('this.$route.path → ' + this.$route.path)
        if (targetPath !== this.$route.path) {
          this.allSidebarHide()
          await this.$router.push({path: targetPath, query: {'projectType': projectType, 'tableRowId': tableRowId, 'suggestionType': suggestionData['suggestionType'][0]}})
          this.$emit('reDrawMemoImage', projectType)
          return false
        } else {
          if (this.$route.query.projectType === undefined || this.$route.query.tableRowId !== tableRowId) {
            this.allSidebarHide()
            await this.$router.push({path: targetPath, query: {'projectType': projectType, 'tableRowId': tableRowId, 'suggestionType': suggestionData['suggestionType'][0]}})
            this.$emit('reDrawMemoImage', projectType)
            return false
          }
        }
      }
    },
    goToProductionInstruction: async function (projectNumber, projectType, tableRowId, suggestionType = '') {
      let suggestionData = localStorage.getItem('suggestionData') ? JSON.parse(localStorage.getItem('suggestionData')) : ''
      // suggestionTypeをセット
      if (suggestionData) {
        if (projectType === 'お客様画像' || projectType === 'ブックマーク') {
          suggestionData['suggestionType'] = [projectType]
          localStorage.setItem('suggestionData', JSON.stringify(suggestionData))
        } else {
          suggestionData['suggestionType'] = [suggestionType]
          localStorage.setItem('suggestionData', JSON.stringify(suggestionData))
        }

        // suggestionDataの情報をdynamoDBに登録
        const updateData = {
          'suggestionData': JSON.stringify(suggestionData),
          'attendeeType': this.consts.attendeeType.florist
        }
        MeetingInfoUpdateModel.apiSetStore(this.$bvModal, updateData, () => {})
      } else {
        if (projectType === 'お客様画像' || projectType === 'ブックマーク') {
          localStorage.setItem('suggestionData', JSON.stringify({'suggestionType': [projectType]}))
        } else {
          localStorage.setItem('suggestionData', JSON.stringify({'suggestionType': [suggestionType]}))
        }

        // suggestionDataの情報をdynamoDBに登録
        const updateData = {
          'suggestionData': localStorage.getItem('suggestionData'),
          'attendeeType': this.consts.attendeeType.florist
        }
        MeetingInfoUpdateModel.apiSetStore(this.$bvModal, updateData, () => {})

        suggestionData = JSON.parse(localStorage.getItem('suggestionData'))
      }
      console.log('suggestionData ↓')
      console.log(suggestionData)
      const targetPath = '/florist/meeting/production_instruction/' + projectNumber
      console.log('targetPath → ' + targetPath)
      console.log('this.$route.path → ' + this.$route.path)
      if (targetPath !== this.$route.path) {
        this.allSidebarHide()
        await this.$router.push({path: targetPath, query: {'projectType': projectType, 'tableRowId': tableRowId, 'suggestionType': suggestionData['suggestionType'][0]}})
        this.$emit('reDrawMemoImage', projectType)
        return false
      } else {
        if (this.$route.query.projectType === undefined || this.$route.query.tableRowId !== tableRowId) {
          this.allSidebarHide()
          await this.$router.push({path: targetPath, query: {'projectType': projectType, 'tableRowId': tableRowId, 'suggestionType': suggestionData['suggestionType'][0]}})
          this.$emit('reDrawMemoImage', projectType)
          return false
        }
      }
    },
    toggleMeetingMemo () {
      this.isMeetingMemoOpen = !this.isMeetingMemoOpen
      if (this.isMeetingMemoOpen && this.loginStatus['prodInst'] !== '1') {
        this.$nextTick(() => {
          this.optimizeCanvasWidth()
        })
      }
    },
    optimizeCanvasWidth () {
      this.isOpenCanvas = !this.isOpenCanvas
      if (this.isOpenCanvas && this.loginStatus['prodInst'] !== '1') {
        this.$refs.drawCanvas.calculateWidth()
      }
    },
    clearCanvas () {
      try {
        if (!this.allClearFlag) {
          this.$refs.drawCanvas.clearCanvas()
        } else {
          this.$refs.drawCanvas.allClearCanvas()
        }
        SignalingModel.sendClickEvent('clearCanvas', this)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    allClearCanvas () {
      let result = window.confirm('過去に保存した手描き線も全てクリアされます。宜しいですか？')
      if (result) {
        this.$refs.drawCanvas.allClearCanvas()
        this.allClearFlag = true
      }
    },
    exportDrawnImage: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      this.$refs.drawCanvas.onExportDrawnImage()
    },
    openAddEstimateItemModal () {
      this.$refs.addEstimateItemModal.showModal()
    },
    reloadEstimate () {
      this.mainGuestEstimateData = {}
      this.mainGuestOptionData = {}
      this.mainOtherEstimateData = {}
      this.guestOtherEstimateData = {}
      this.itemEstimateData = {}
      this.mainRowCount = 0
      this.guestRowCount = 0
    },
    changePenColor (e) {
      this.penColor = e.target.value
    },
    toCommaSeparated (str) {
      if (str) {
        try {
          return parseInt(str, 10).toLocaleString()
        } catch (err) {
          return ''
        }
      }
      return str
    },
    allSidebarHide () {
      this.showSidebar1 = false
      this.showSidebar2 = false
      this.showSidebar3 = false
      this.showSidebar4 = false
      if (document.getElementById('estimate-trigger').classList.contains('active')) {
        document.getElementById('estimate-trigger').classList.toggle('active')
      }
      if (document.getElementById('overall-memo-btn').classList.contains('active')) {
        document.getElementById('overall-memo-btn').classList.toggle('active')
      }
      if (document.getElementById('meeting-memo-btn').classList.contains('active')) {
        document.getElementById('meeting-memo-btn').classList.toggle('active')
      }
    },
    ownShowAndOtherbSidebarHide (ownbSidebarId) {
      if (ownbSidebarId === 'sidebar-1') {
        this.showSidebar1 = !this.showSidebar1
        if (this.showSidebar1) {
          const maxIndex = Math.max(this.maxSideberZIndex1, this.maxSideberZIndex2, this.maxSideberZIndex3, this.maxSideberZIndex4)
          this.maxSideberZIndex1 = maxIndex + 1
        }
      }
      if (ownbSidebarId === 'sidebar-2') {
        this.showSidebar2 = !this.showSidebar2
        if (this.showSidebar2) {
          const maxIndex = Math.max(this.maxSideberZIndex1, this.maxSideberZIndex2, this.maxSideberZIndex3, this.maxSideberZIndex4)
          this.maxSideberZIndex2 = maxIndex + 1
        }
      } else if (ownbSidebarId === 'sidebar-3') {
        this.showSidebar3 = !this.showSidebar3
        if (this.showSidebar3) {
          this.setMemo()
          const maxIndex = Math.max(this.maxSideberZIndex1, this.maxSideberZIndex2, this.maxSideberZIndex3, this.maxSideberZIndex4)
          this.maxSideberZIndex3 = maxIndex + 1
        }
        document.getElementById('overall-memo-btn').classList.toggle('active')
      } else if (ownbSidebarId === 'sidebar-4') {
        this.showSidebar4 = !this.showSidebar4
        if (this.showSidebar4) {
          this.setMemo()
          const maxIndex = Math.max(this.maxSideberZIndex1, this.maxSideberZIndex2, this.maxSideberZIndex3, this.maxSideberZIndex4)
          this.maxSideberZIndex4 = maxIndex + 1
        }
        document.getElementById('meeting-memo-btn').classList.toggle('active')
      }

      // 全部非表示になったら、10000に戻す
      if (!this.showSidebar1 && !this.showSidebar2 && !this.showSidebar3 && !this.showSidebar4) {
        this.maxSideberZIndex1 = 1100
        this.maxSideberZIndex2 = 1100
        this.maxSideberZIndex3 = 1100
        this.maxSideberZIndex4 = 1100
      }
    },
    sectionSClick: async function (id, sectionL, sectionM, event) {
      this.estimateOverlayShow = true

      let sectionSMenuBoard = document.getElementById(id)
      let closeboxId = id.replace('SectionS', 'SectionSClose')
      let sectionSMenuCloseBox = document.getElementById(closeboxId)
      var notChangeFlg = false

      let checkboxId = id.replace('SectionS', 'Change')
      if (document.getElementById(checkboxId)) {
        notChangeFlg = ((!document.getElementById(checkboxId).checked && this.loginStatus['afterMTG'] === '1') || this.loginStatus['prodInst'] === '1')
      }

      if (!notChangeFlg) {
        if (sectionSMenuBoard.style.display !== 'block') {
          // 小区分の窓をすべて閉じる
          var elements = document.getElementsByClassName('sectionS-menu-board')
          for (var i = 0; i < elements.length; i = i + 1) {
            elements[i].style.display = 'none'
          }
          // 小区分の閉じるボタンをすべて閉じる
          elements = document.getElementsByClassName('sectionS-menu-close')
          for (i = 0; i < elements.length; i = i + 1) {
            elements[i].style.display = 'none'
          }

          // 見積スライドの情報を取得
          let sidebar2 = document.getElementById('sidebar-2')
          var sidebar2top = sidebar2.getBoundingClientRect().top
          var sidebar2left = sidebar2.getBoundingClientRect().left

          // クリックした小区分の窓を表示
          sectionSMenuBoard.style.display = 'block'
          sectionSMenuBoard.style.left = event.clientX + 'px'
          sectionSMenuBoard.style.top = event.clientY + 'px'

          // クリックした小区分の窓の閉じるボタンを表示
          sectionSMenuCloseBox.style.display = 'block'
          sectionSMenuCloseBox.style.left = (event.clientX + 180) + 'px'
          sectionSMenuCloseBox.style.top = (event.clientY - 20) + 'px'
        } else {
          sectionSMenuBoard.style.display = 'none'
          sectionSMenuCloseBox.style.display = 'none'
        }

        // 小区分選択肢を取得
        this.EstimateSectionSData = []
        const CategoryListResult = await CategoryListModel.apiSetStore(this.$bvModal, {'sectionL': sectionL, 'sectionM': sectionM}, () => {})
        for (const key in CategoryListResult['records']) {
          this.EstimateSectionSData.push(CategoryListResult['records'][key]['小分類']['value'])
        }
      }

      this.estimateOverlayShow = false
    },
    sectionSMenuClick: async function (type, key, index, ssdata) {
      this.estimateOverlayShow = true

      if (type === 'mainGuest') {
        this.mainGuestEstimateData[key][index]['sectionS'] = ssdata
      }
      if (type === 'mainGuestOption') {
        this.mainGuestOptionData[key][index]['sectionS'] = ssdata
      }
      if (type === 'mainOther') {
        this.mainOtherEstimateData[key]['items'][index]['sectionS'] = ssdata
      }
      if (type === 'guestOther') {
        this.guestOtherEstimateData[key]['items'][index]['sectionS'] = ssdata
      }
      if (type === 'itemEstimate') {
        this.itemEstimateData[key][index]['sectionS'] = ssdata
      }

      this.estimateOverlayShow = false
    },
    disableInput: async function (index, isMainGuest) {
      let itemName = 'itemName' + index
      let itemPrice = 'itemPrice' + index
      let quantity = 'quantity' + index
      let note = 'note' + index
      let discount = 'discount' + index
      let packPrice = 'packPrice' + index
      let packQuantity = 'packQuantity' + index
      let packDiscount = 'packDiscount' + index
      let sdpRate = 'sdpRate' + index
      if (isMainGuest) {
        itemName = 'mainGuestItemName' + index
        itemPrice = 'mainGuestItemPrice' + index
        quantity = 'mainGuestQuantity' + index
        note = 'mainGuestNote' + index
        discount = 'mainGuestDiscount' + index
        packPrice = 'mainGuestPackPrice' + index
        packQuantity = 'mainGuestPackQuantity' + index
        packDiscount = 'mainGuestPackDiscount' + index
        sdpRate = 'mainGuestSdpRate' + index
      }
      const get = e => document.getElementById(e)
      if (get(itemPrice).disabled === true && get(quantity).disabled === true && get(note).disabled === true) {
        get(itemName).removeAttribute('disabled')
        get(itemPrice).removeAttribute('disabled')
        get(quantity).removeAttribute('disabled')
        get(note).removeAttribute('disabled')
        get(discount).removeAttribute('disabled')
        if (get(packPrice) && get(packQuantity) && get(packDiscount)) {
          get(packPrice).removeAttribute('disabled')
          get(packQuantity).removeAttribute('disabled')
          get(packDiscount).removeAttribute('disabled')
        }
        if (get(sdpRate)) {
          get(sdpRate).removeAttribute('disabled')
        }
      } else {
        get(itemName).setAttribute('disabled', true)
        get(itemPrice).setAttribute('disabled', true)
        get(quantity).setAttribute('disabled', true)
        get(note).setAttribute('disabled', true)
        get(discount).setAttribute('disabled', true)
        if (get(packPrice) && get(packQuantity) && get(packDiscount)) {
          get(packPrice).setAttribute('disabled', true)
          get(packQuantity).setAttribute('disabled', true)
          get(packDiscount).setAttribute('disabled', true)
        }
        if (get(sdpRate)) {
          get(sdpRate).setAttribute('disabled', true)
        }
      }
    },
    changeRowDisabled (e) {
      for (const inputElm of e.target.parentNode.parentNode.querySelectorAll('textarea[name="itemName"],input[name="itemPrice"],input[name="quantity"],textarea[name="note"],input[name="packPrice"],input[name="packQuantity"],input[name="packDiscount"],input[name="discount"]')) {
        // 商品単価、数量、備考、パック単価、割引率の活性状態を反転させる
        inputElm.disabled = !inputElm.disabled
      }
    },
    setMainGuestImageDisplayData (data) {
      this.mainGuestImageDisplayData = data
    },
    setMainGuestProdInstImageDisplayData (data) {
      this.mainGuestProdInstImageDisplayData = data
    },
    updateProductionInstruction: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      this.estimateOverlayShow = true
      // 見積表示フラグ更新用パラメータ
      const displayImageItems = document.getElementsByName('prodInstDisplayImageCheckbox')
      let displayImageParams = {}
      for (let i = 0; i < displayImageItems.length; i++) {
        const info = JSON.parse(displayImageItems[i].value)
        const category = info['category']
        if (category === 'アフターブーケ' || category === 'エターナルブーケ') {
          if ('エターナルブーケ' in displayImageParams === false && 'アフターブーケ' in displayImageParams === false) {
            displayImageParams[category] = {}
          }
        } else {
          if (category in displayImageParams === false) {
            displayImageParams[category] = {}
          }
        }
        if (info['itemCode'] !== null) {
          if (category === 'アフターブーケ' && 'エターナルブーケ' in displayImageParams) {
            displayImageParams['エターナルブーケ'][info['itemCode'] + '&' + info['serialNo']] = document.getElementById(info['id']).checked
          } else if (category === 'エターナルブーケ' && 'アフターブーケ' in displayImageParams) {
            displayImageParams['アフターブーケ'][info['itemCode'] + '&' + info['serialNo']] = document.getElementById(info['id']).checked
          } else {
            displayImageParams[category][info['itemCode'] + '&' + info['serialNo']] = document.getElementById(info['id']).checked
          }
        } else if (info['mainOtherRecordNo']) {
          displayImageParams[category][info['serialNo'] + 'main' + info['mainOtherRecordNo']] = document.getElementById(info['id']).checked
        } else if (info['guestOtherRecordNo']) {
          displayImageParams[category][info['serialNo'] + 'guest' + info['guestOtherRecordNo']] = document.getElementById(info['id']).checked
        }
      }
      displayImageParams['メインテーブル・ゲストテーブル'] = this.mainGuestProdInstImageDisplayData

      // 見積更新用パラメータ
      let registData = {}
      let estimateTbody = document.getElementById('estimate-table').getElementsByTagName('tbody')
      // 指名料や花材指定料は除外
      const OTHER_FEES_ID = 'other-fees-tbody'
      estimateTbody = Array.prototype.filter.call(estimateTbody, e => e.id !== OTHER_FEES_ID)

      // 数値項目の入力チェック
      let isNumericFlg = false
      for (const tbodyKey of Object.keys(estimateTbody)) {
        let tr = estimateTbody[tbodyKey].getElementsByTagName('tr')
        for (const td of Object.values(tr)) {
          let estimateInputs = td.getElementsByTagName('input')
          let tableId = td.getElementsByTagName('input').tableId.value

          console.log('tableId' + tableId)
          console.log(document.getElementById(tableId))

          // SDP委託率チェック
          const sdpRateErrElem = document.getElementById(tableId).querySelectorAll('input[name="sdpRate"]+.numeric-errors')
          if (sdpRateErrElem.length > 0) {
            sdpRateErrElem[0].innerText = ''
          }
          if (estimateInputs['sdpRate']) {
            if (estimateInputs['sdpRate'].value === '') {
              estimateInputs['sdpRate'].value = '0'
            }
            if (this.isDecimal(estimateInputs['sdpRate'].value) === false) {
              console.log('sdpRate error')
              sdpRateErrElem[0].innerText = '0.00以上の数値で入力してください'
              isNumericFlg = true
            } else {
              if (Number(estimateInputs['sdpRate'].value) < 0) {
                console.log('sdpRate error')
                sdpRateErrElem[0].innerText = '0.00以上の数値で入力してください'
                isNumericFlg = true
              }
            }
          }
        }
      }

      // 制作担当チェック
      const prodBaseErrElem = document.getElementById('prodBaseErrElem')
      if (prodBaseErrElem) {
        prodBaseErrElem.innerText = ''
      }
      if (this.prodBaseName === '') {
        console.log('prodBaseName error')
        prodBaseErrElem.innerText = '選択してください'
        isNumericFlg = true
      }

      // 委託有無チェック
      const operationPtnErrElem = document.getElementById('operationPtnErrElem')
      if (operationPtnErrElem) {
        operationPtnErrElem.innerText = ''
      }
      if (this.operationPtnName === '') {
        console.log('operationPtnName error')
        operationPtnErrElem.innerText = '選択してください'
        isNumericFlg = true
      }

      console.log('エラー確認')
      // 数値エラーの場合は処理終了
      if (isNumericFlg === true) {
        console.log('数値エラー')
        this.estimateOverlayShow = false
        return
      }

      // 見積更新用パラメータ
      for (const tbodyKey of Object.keys(estimateTbody)) {
        let tr = estimateTbody[tbodyKey].getElementsByTagName('tr')
        let category = estimateTbody[tbodyKey].getElementsByTagName('input').category.value
        if (category in registData === false) {
          registData[category] = {}
        }
        for (const td of Object.values(tr)) {
          let estimateInputs = td.getElementsByTagName('input')
          console.log(estimateInputs)
          let tableId = td.getElementsByTagName('input').tableId.value
          registData[category][tableId] = {}
          registData[category][tableId]['sdpRate'] = estimateInputs['sdpRate'].value
        }
      }
      let prodBaseCodeForUpdate = ''
      for (const pbl in this.prodBaseList) {
        if (this.prodBaseName === this.prodBaseList[pbl]['制作拠点名']) {
          prodBaseCodeForUpdate = this.prodBaseList[pbl]['制作拠点コード']
        }
      }

      registData['form'] = {}
      registData['form']['operationPtn'] = this.shiftOperationPtn(false, this.operationPtnName)
      registData['form']['prodBaseCode'] = prodBaseCodeForUpdate

      // 制作関係アプリで制作指示表示状態を更新
      await ProductionInstructionImageUpdateModel.apiSetStore(this.$bvModal, displayImageParams, () => {})
      // 案件情報アプリの見積情報を更新
      await EstimateUpdateModel.apiSetStore(this.$bvModal, registData, () => {})
      // 制作拠点が変更されていた場合、アラートメッセージを表示する
      /* if (this.prodBaseName !== this.beforeChangeProdBaseName) {
        this.$refs.commonModal.msgBoxOk(this.consts.messages.changeProdBase)
        this.beforeChangeProdBaseName = this.prodBaseName
      } */
      this.estimateOverlayShow = false
    },
    reconnect () {
      sessionStorage.setItem('noDisplayMessageFlag', 'true')
      // 接続OFF
      logoff.logoff_kyoutu()

      // 画面遷移
      console.log('reconnect')
      MeetingInfoGetModel.apiSetStore(this.$bvModal, () => {
        const meetingInfoStore = MeetingInfoGetModel.getStore()
        let targetPath = '/florist/meeting/agenda'
        console.log(meetingInfoStore)
        if (meetingInfoStore) {
          let meetingurl = meetingInfoStore.meetingURL['currentURLPath']
          console.log(meetingurl)
          if (meetingurl !== '') {
            targetPath = '/florist/' + meetingurl
            if (meetingInfoStore.meetingURL['operatingPrivilege'] === '0') {
              fstore.commit('setIsOperationPossible', true)
            } else {
              fstore.commit('setIsOperationPossible', false)
            }

            const suggestionData = meetingInfoStore.meetingURL['suggestionData']
            if (suggestionData) {
              localStorage.setItem('suggestionData', suggestionData)
            }
          }
        }
        CommonLogModel.apiSetStore(this.$bvModal, {'user': 'florist', 'timestampMs': Date.now(), 'current_path': this.$route.path, 'reloadPath': targetPath}, () => {})
        this.allSidebarHide()
        this.$router.go({path: targetPath, force: true})
      })
    },
    meetingIdCheck: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      MeetingInfoGetModel.apiSetStore(this.$bvModal, () => {
        var meetingInfoStore = MeetingInfoGetModel.getStore()
        const meetingSessionInfo = JSON.parse(sessionStorage.getItem('meeting'))
        if (meetingSessionInfo['MeetingId'] !== meetingInfoStore.meetingURL['meetingId']) {
          this.$refs.commonModalMeetingIdCheck.msgBoxConfirm('お客様と異なるミーティングルームに入室しています。正しいミーティングルームに移動しますか？')
        } else {
          this.reconnect()
        }
      })
    },
    restartMeeting: async function () {
      const meetingStartParams = {'attendeeType': this.consts.attendeeType.florist}
      const restartResult = await MeetingStartModel.apiSetStore(this.$bvModal, meetingStartParams, null, () => {
        // ミーティング参加失敗時
        this.$router.push('/florist/meeting/error')
      })
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'current_path': this.$route.path, 'comment': 'ミーティングスタート'}, () => {})
      if (restartResult) {
        // ミーティング参加成功時
        sessionStorage.meeting = await JSON.stringify(restartResult.meeting)
        sessionStorage.attendee = await JSON.stringify(restartResult.attendee)
        this.reconnect()
      } else {
        this.overlayShow = false
        return false
      }
    },
    cookieProjectNumberCheck: async function () {
      let currentCookieProjectNumber = ''
      let params = ['projectNumber']
      currentCookieProjectNumber = await CookieInfoModel.apiSetStore(this.$bvModal, params, () => {})
      console.log(currentCookieProjectNumber['cookieInfo'])
      console.log(this.cookieProjectNumber)
      if (currentCookieProjectNumber['cookieInfo'] === this.cookieProjectNumber) {
        return true
      } else {
        return false
      }
    },
    selectAllStyle () {
      if (this.isAllSelected) {
        // 全選択対象のスタイルのみ、非選択状態にする
        for (let i = 0; i < this.allSelectList.length; i++) {
          if (this.style.indexOf(this.allSelectList[i]) >= 0) {
            this.style.splice(this.style.indexOf(this.allSelectList[i]), 1)
          }
        }
        this.isAllSelected = false
      } else {
        for (let k in this.viewStyles) {
          // 全選択対象のスタイルのみ、選択状態にする
          if (!this.notAllSelectList.includes(this.viewStyles[k]['styleName']) && !this.style.includes(this.viewStyles[k]['styleName'])) {
            this.style.push(this.viewStyles[k]['styleName'])
          }
        }
        this.isAllSelected = true
      }
    },
    select (styleData) {
      // 全選択対象ではないスタイルは何もしない
      if (this.notAllSelectList.includes(styleData.styleName)) {
        return
      }
      if (this.allSelectList.every((num) => this.style.includes(num))) {
        this.isAllSelected = true
      } else {
        this.isAllSelected = false
      }
    },
    shiftOperationPtn (mode, value) {
      let opPtn = value
      if (mode) {
        if (opPtn === '1型') {
          return '1型：完全内製'
        } else if (opPtn === '2型') {
          return '2型：拠点制作'
        } else if (opPtn === '3型') {
          return '3型：葬儀'
        } else if (opPtn === '4型') {
          return '4型：制作・納品外注'
        } else if (opPtn === '制作委託') {
          return '制作外注'
        } else if (opPtn === '5型') {
          return '5型：完全外注'
        } else {
          return ''
        }
      } else {
        if (opPtn === '1型：完全内製') {
          return '1型'
        } else if (opPtn === '2型：拠点制作') {
          return '2型'
        } else if (opPtn === '3型：葬儀') {
          return '3型'
        } else if (opPtn === '4型：制作・納品外注') {
          return '4型'
        } else if (opPtn === '制作外注') {
          return '制作委託'
        } else if (opPtn === '5型：完全外注') {
          return '5型'
        } else {
          return ''
        }
      }
    },
    goToProductSelectionFromBookmark: async function (projectNumber, projectType, suggestionType) {
      console.log(projectNumber)
      console.log(projectType)
      console.log(suggestionType)
      let suggestionData = localStorage.getItem('suggestionData') ? JSON.parse(localStorage.getItem('suggestionData')) : {}
      suggestionData['suggestionType'] = suggestionType ? [suggestionType] : []
      suggestionData['projectType'] = projectType ? [projectType] : []
      localStorage.setItem('suggestionData', JSON.stringify(suggestionData))
      // suggestionDataの情報をdynamoDBに登録
      const updateData = {
        'suggestionData': JSON.stringify(suggestionData),
        'attendeeType': this.consts.attendeeType.florist
      }
      MeetingInfoUpdateModel.apiSetStore(this.$bvModal, updateData, () => {})
      const targetPath = '/florist/meeting/product_selection/' + projectNumber
      const currentSuggestionType = JSON.parse(localStorage.getItem('suggestionData')).suggestionType && JSON.parse(localStorage.getItem('suggestionData')).suggestionType.length > 0 ? JSON.parse(localStorage.getItem('suggestionData')).suggestionType[0] : ''
      await SignalingModel.sendClickEvent('productDetailFromBookmark', this, {
        'projectType': JSON.parse(localStorage.getItem('suggestionData')).projectType[0],
        'suggestionType': currentSuggestionType,
        'projectNumber': projectNumber
      })
      this.$router.push({path: targetPath, query: {'projectType': JSON.parse(localStorage.getItem('suggestionData')).projectType[0], 'suggestionType': currentSuggestionType, 'fromBookmark': true}})
    }
  }
}
</script>
<style scoped>
a.disabled {
  pointer-events: none;
}
li {
  list-style-type: none;
}
.w-70 {
    width: 70%!important;
}
.w-30 {
    width: 30%!important;
}
.w-20 {
    width: 20%!important;
}
.w-5 {
    width: 5%!important;
}
.flex-right {
    display: flex;
    justify-content:flex-end;
}
.form-check-inline {
  margin-bottom: .75rem;
}
.form-check-label {
  font-size: 1rem;
}
.clear-form {
  position: absolute;
  right: 20px;
  top: 0;
  bottom: 0;
  margin: auto;
  cursor: pointer;
  color: #343a40;
}
.icon-pointer {
  cursor: pointer;
}

.navbar {
  padding: .5rem 1rem;
}

.numeric-errors {
  color: #ff0000;
}
.item-note {
  font-size: 0.5rem;
  padding: 0px;
  overflow-y: hidden!important;
}
.dropdown-toggle-no-caret {
  caret-color: transparent!important;
}
.sectionS-menu-board {
  display:none;
  position:fixed;
  left:0px;
  top:0px;
  width:200px;
  border:1px solid #000;
  background-color:#fff;
  z-index:150;
}
.sectionS-menu {
  cursor:pointer;
}
.sectionS-menu-close {
  display:none;
  position:fixed;
  left:0px;
  top:0px;
  width:18px;
  border:1px solid #000;
  background-color:#CACFCE;
  z-index:150;
  font-weight:bold;
}

#header-image-upload-btn {
  padding: 3px 15px;
  font-size: 1.2rem;
}
</style>
